//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthorizedApiBase {
    private readonly config: IConfig;

    protected constructor(config: IConfig) {
        this.config = config;
    }

    protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
        return {
            ...options,
            headers: {
                ...options.headers,
                Authorization: await this.config.getAuthorization(),
            },
        };
    };
}

export class AlarmsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Alarms Heat Map
     * @return The bucket objects
     */
    getUsersFromAzure(query: GetUsersFromAzureQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfAzureUsersModel> {
        let url_ = this.baseUrl + "/api/Alarms/GetUsersFromAzure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersFromAzure(_response);
        });
    }

    protected processGetUsersFromAzure(response: Response): Promise<ResultOfListOfAzureUsersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAzureUsersModel>(null as any);
    }
}

export class ApiPanelsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets panels from api
     * @return The list of entities
     */
    getPanels(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfPanelsResponseModel> {
        let url_ = this.baseUrl + "/api/ApiPanels/GetPanels/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPanels(_response);
        });
    }

    protected processGetPanels(response: Response): Promise<ResultOfPanelsResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelsResponseModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPanelsResponseModel>(null as any);
    }

    /**
     * Filter Panels
     * @return The list of entities
     */
    filterPanelsInfo(command: FilterPanelsInfoCommand, signal?: AbortSignal | undefined): Promise<ResultOfPanelItemsModel> {
        let url_ = this.baseUrl + "/api/ApiPanels/FilterPanelsInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFilterPanelsInfo(_response);
        });
    }

    protected processFilterPanelsInfo(response: Response): Promise<ResultOfPanelItemsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPanelItemsModel>(null as any);
    }

    /**
     * Reset Filter Panels
     * @return The list of entities
     */
    resetFilterPanelsInfo(command: ResetFilterPanelsInfoCommand, signal?: AbortSignal | undefined): Promise<ResultOfPanelItemsModel> {
        let url_ = this.baseUrl + "/api/ApiPanels/ResetFilterPanelsInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetFilterPanelsInfo(_response);
        });
    }

    protected processResetFilterPanelsInfo(response: Response): Promise<ResultOfPanelItemsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPanelItemsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPanelItemsModel>(null as any);
    }

    /**
     * Reset Filter Panels
     * @return The list of entities
     */
    resetAllFilterPanelsInfo(command: ResetAllFilterPanelsInfoCommand, signal?: AbortSignal | undefined): Promise<ResultOfListOfPanelItemsModel> {
        let url_ = this.baseUrl + "/api/ApiPanels/ResetAllFilterPanelsInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetAllFilterPanelsInfo(_response);
        });
    }

    protected processResetAllFilterPanelsInfo(response: Response): Promise<ResultOfListOfPanelItemsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Incoherences", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPanelItemsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfPanelItemsModel>(null as any);
    }
}

export class AppConfigurationService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the current configuration for the application
     * @return The related resources
     */
    getAppConfiguration(signal?: AbortSignal | undefined): Promise<ResultOfAppConfigurationViewModel> {
        let url_ = this.baseUrl + "/api/AppConfiguration/GetAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppConfiguration(_response);
        });
    }

    protected processGetAppConfiguration(response: Response): Promise<ResultOfAppConfigurationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAppConfigurationViewModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAppConfigurationViewModel>(null as any);
    }

    /**
     * Update the configuration of application
     * @return Ok
     */
    updateAppConfiguration(command: UpdateAppConfigurationCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AppConfiguration/UpdateAppConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAppConfiguration(_response);
        });
    }

    protected processUpdateAppConfiguration(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Gets the application identity configuration
     * @return The related resources
     */
    getIdentityConfiguration(signal?: AbortSignal | undefined): Promise<ResultOfIdentityConfiguration> {
        let url_ = this.baseUrl + "/api/AppConfiguration/identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityConfiguration(_response);
        });
    }

    protected processGetIdentityConfiguration(response: Response): Promise<ResultOfIdentityConfiguration> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIdentityConfiguration;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIdentityConfiguration>(null as any);
    }

    /**
     * Gets the ip port where the application is running
     * @return The related resources
     */
    getAppUrl(query: GetAppUrlQuery, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/AppConfiguration/getAppUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppUrl(_response);
        });
    }

    protected processGetAppUrl(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }
}

export class AssetControlService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates an asset control
     * @return Status
     */
    addAssetControlView(command: AddAssetControlViewCommand, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/AssetControl/AddAssetControlView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssetControlView(_response);
        });
    }

    protected processAddAssetControlView(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    /**
     * Edit an asset control
     * @return Status
     */
    editAssetControlView(command: EditAssetControlViewCommand, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetControlViewModel> {
        let url_ = this.baseUrl + "/api/AssetControl/EditAssetControlView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditAssetControlView(_response);
        });
    }

    protected processEditAssetControlView(response: Response): Promise<ResultOfFullAssetControlViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetControlViewModel>(null as any);
    }

    /**
     * Delete asset control view
     * @return Status
     */
    deleteAssetControlView(command: DeleteAssetControlViewCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/DeleteAssetControlView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssetControlView(_response);
        });
    }

    protected processDeleteAssetControlView(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get project Asset Control Views
     * @return The list of entities
     */
    getAllAssetControlViews(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfViewsModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetAllAssetControlViews/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAssetControlViews(_response);
        });
    }

    protected processGetAllAssetControlViews(response: Response): Promise<ResultOfViewsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfViewsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfViewsModel>(null as any);
    }

    /**
     * Get project Asset Control View
     * @return Asset control view
     */
    getAssetControlView(projectId: string | null, viewId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetControlViewModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetAssetControlView/{projectId}/{viewId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetControlView(_response);
        });
    }

    protected processGetAssetControlView(response: Response): Promise<ResultOfFullAssetControlViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetControlViewModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetControlViewModel>(null as any);
    }

    /**
     * Get project Asset Control Views to render in viewer
     * @return The list of entities
     */
    getAllAssetControlViewsRender(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfRenderViewsModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetAllAssetControlViewsRender/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAssetControlViewsRender(_response);
        });
    }

    protected processGetAllAssetControlViewsRender(response: Response): Promise<ResultOfRenderViewsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRenderViewsModel>(null as any);
    }

    /**
     * Get render asset control view
     * @return Render view
     */
    renderAssetControlView(projectId: string | null, viewId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfRenderViewModel> {
        let url_ = this.baseUrl + "/api/AssetControl/RenderAssetControlView/{projectId}/{viewId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (viewId === undefined || viewId === null)
            throw new Error("The parameter 'viewId' must be defined.");
        url_ = url_.replace("{viewId}", encodeURIComponent("" + viewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenderAssetControlView(_response);
        });
    }

    protected processRenderAssetControlView(response: Response): Promise<ResultOfRenderViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRenderViewModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRenderViewModel>(null as any);
    }

    /**
     * Get Excel Info.
    Starting from the file name (including the extension) it returns the sheets, columns and the first 20 values ​​of each column to be previewed in the front.
    If there are no values ​​in the cells, it still returns 20 positions with None.
     * @return The list of entities
     */
    getExcelInfo(projectId: string | null, blobName: string | null, signal?: AbortSignal | undefined): Promise<ResultOfExcelInfoModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetExcelInfo/{projectId}/{blobName}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (blobName === undefined || blobName === null)
            throw new Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExcelInfo(_response);
        });
    }

    protected processGetExcelInfo(response: Response): Promise<ResultOfExcelInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelInfoModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfExcelInfoModel>(null as any);
    }

    /**
     * Get Asset Control
     * @return The list of entities
     */
    getAssetControl(projectId: string | null, controlId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfAssetControlModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetAssetControl/{projectId}/{controlId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (controlId === undefined || controlId === null)
            throw new Error("The parameter 'controlId' must be defined.");
        url_ = url_.replace("{controlId}", encodeURIComponent("" + controlId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetControl(_response);
        });
    }

    protected processGetAssetControl(response: Response): Promise<ResultOfAssetControlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAssetControlModel>(null as any);
    }

    /**
     * Get Available Asset Control
     * @return The list of entities
     */
    getAvailableAssetControls(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfAssetControlRulesModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetAvailableAssetControls/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableAssetControls(_response);
        });
    }

    protected processGetAvailableAssetControls(response: Response): Promise<ResultOfAssetControlRulesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetControlRulesModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAssetControlRulesModel>(null as any);
    }

    /**
     * Get asset control file names
     * @return The list of entities
     */
    getFileNames(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfString> {
        let url_ = this.baseUrl + "/api/AssetControl/GetFileNames/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileNames(_response);
        });
    }

    protected processGetFileNames(response: Response): Promise<ResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfString>(null as any);
    }

    addFile(projectId: string | null | undefined, name: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/AssetControl/AddFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddFile(_response);
        });
    }

    protected processAddFile(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    updateFile(projectId: string | null | undefined, name: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/UpdateFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFile(_response);
        });
    }

    protected processUpdateFile(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Downloads a document
     * @return OK
     */
    downloadDocument(command: DownloadFileToAssetControlCommand, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/AssetControl/DownloadDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get Excel Pages Asset Control
     * @return The list of entities
     */
    getExcelPages(projectId: string | null, fileName: string | null, signal?: AbortSignal | undefined): Promise<ResultOfExcelPagesModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetExcelPages/{projectId}/{fileName}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExcelPages(_response);
        });
    }

    protected processGetExcelPages(response: Response): Promise<ResultOfExcelPagesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelPagesModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfExcelPagesModel>(null as any);
    }

    /**
     * Get Excel Pages Asset Control
     * @return The list of entities
     */
    getExcelColumns(projectId: string | null, fileName: string | null, page: string | null, signal?: AbortSignal | undefined): Promise<ResultOfExcelColumnsModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetExcelColumns/{projectId}/{fileName}/{page}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExcelColumns(_response);
        });
    }

    protected processGetExcelColumns(response: Response): Promise<ResultOfExcelColumnsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfExcelColumnsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfExcelColumnsModel>(null as any);
    }

    /**
     * Create asset control
     * @return Status
     */
    createAssetControl(command: CreateAssetControlCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/CreateAssetControl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAssetControl(_response);
        });
    }

    protected processCreateAssetControl(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Update asset control
     * @return Status
     */
    editAssetControl(command: EditAssetControlCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/EditAssetControl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditAssetControl(_response);
        });
    }

    protected processEditAssetControl(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Update asset control rules
     * @return Status
     */
    editAssetControlRules(command: EditAssetControlRulesCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/EditAssetControlRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditAssetControlRules(_response);
        });
    }

    protected processEditAssetControlRules(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete asset control
     * @return Status
     */
    deleteAssetControl(command: DeleteAssetControlCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetControl/DeleteAssetControl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssetControl(_response);
        });
    }

    protected processDeleteAssetControl(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get TXT rules
     * @return The list of entities
     */
    getTXTRulesByVista(projectId: string | null, idVista: string | null, signal?: AbortSignal | undefined): Promise<ResultOfTXTRulesModel> {
        let url_ = this.baseUrl + "/api/AssetControl/GetTXTRulesByVista/{projectId}/{idVista}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (idVista === undefined || idVista === null)
            throw new Error("The parameter 'idVista' must be defined.");
        url_ = url_.replace("{idVista}", encodeURIComponent("" + idVista));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTXTRulesByVista(_response);
        });
    }

    protected processGetTXTRulesByVista(response: Response): Promise<ResultOfTXTRulesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTXTRulesModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfTXTRulesModel>(null as any);
    }
}

export class AssetEditorService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create Asset
     * @return The bucket objects
     */
    createAsset(command: CreateAssetCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetEditor/CreateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAsset(_response);
        });
    }

    protected processCreateAsset(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete Asset
     * @return The bucket objects
     */
    deleteAsset(command: DeleteAssetCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetEditor/DeleteAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAsset(_response);
        });
    }

    protected processDeleteAsset(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Update Asset
     * @return The bucket objects
     */
    updateAsset(command: UpdateAssetCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetEditor/UpdateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Asset
     * @return The bucket objects
     */
    getAsset(query: GetAssetQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetAssetModel> {
        let url_ = this.baseUrl + "/api/AssetEditor/GetAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAsset(_response);
        });
    }

    protected processGetAsset(response: Response): Promise<ResultOfGetAssetModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetAssetModel>(null as any);
    }

    /**
     * Find The Father
     * @return The bucket objects
     */
    findTheFather(query: FindTheFatherQuery, signal?: AbortSignal | undefined): Promise<ResultOfFindTheFatherModel> {
        let url_ = this.baseUrl + "/api/AssetEditor/FindTheFather";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindTheFather(_response);
        });
    }

    protected processFindTheFather(response: Response): Promise<ResultOfFindTheFatherModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFindTheFatherModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFindTheFatherModel>(null as any);
    }

    /**
     * List All Tags
     * @return The bucket objects
     */
    listAllTags(query: ListAllTagsQuery, signal?: AbortSignal | undefined): Promise<ResultOfListAllTagsModel> {
        let url_ = this.baseUrl + "/api/AssetEditor/ListAllTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processListAllTags(_response);
        });
    }

    protected processListAllTags(response: Response): Promise<ResultOfListAllTagsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListAllTagsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListAllTagsModel>(null as any);
    }
}

export class AssetsInformationService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets All Assets with information
     * @return The list of entities
     */
    getAllAssets(query: GetAllAssetsQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfIndexModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAllAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAssets(_response);
        });
    }

    protected processGetAllAssets(response: Response): Promise<ResultOfListOfIndexModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfIndexModel>(null as any);
    }

    /**
     * Gets Asset information
     * @return The entity
     */
    getAssetInformation(projectId: string | null, dbId: number, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetInformation/{projectId}/{dbId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (dbId === undefined || dbId === null)
            throw new Error("The parameter 'dbId' must be defined.");
        url_ = url_.replace("{dbId}", encodeURIComponent("" + dbId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetInformation(_response);
        });
    }

    protected processGetAssetInformation(response: Response): Promise<ResultOfFullAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetInformationModel>(null as any);
    }

    /**
     * Gets Asset information
     * @return The entity
     */
    getAssetInformationByTag(projectId: string | null, tag: string | null, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetInformationByTag/{projectId}/{tag}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetInformationByTag(_response);
        });
    }

    protected processGetAssetInformationByTag(response: Response): Promise<ResultOfFullAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetInformationModel>(null as any);
    }

    /**
     * Gets Asset information
     * @return The entity
     */
    getAssetInformationById(projectId: string | null, id: string | null, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetInformationById/{projectId}/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetInformationById(_response);
        });
    }

    protected processGetAssetInformationById(response: Response): Promise<ResultOfFullAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetInformationModel>(null as any);
    }

    /**
     * Gets Asset information
     * @return The entity
     */
    getAssetsDbIds(query: GetAssetsDbIdsQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfIndexModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetsDbIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsDbIds(_response);
        });
    }

    protected processGetAssetsDbIds(response: Response): Promise<ResultOfListOfIndexModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfIndexModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfIndexModel>(null as any);
    }

    /**
     * Gets All Property Categories from the model
     * @param projectId (optional) 
     * @return The list of entities
     */
    getCategories(model: string | null, projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetCategories/{model}?";
        if (model === undefined || model === null)
            throw new Error("The parameter 'model' must be defined.");
        url_ = url_.replace("{model}", encodeURIComponent("" + model));
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCategories(_response);
        });
    }

    protected processGetCategories(response: Response): Promise<ResultOfIReadOnlyCollectionOfCategoryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCategoryModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIReadOnlyCollectionOfCategoryModel>(null as any);
    }

    /**
     * Gets All Work Orders with information
     * @return The list of entities
     */
    getWorkOrders(plannedDate: Date, signal?: AbortSignal | undefined): Promise<ResultOfAPIResponseModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetWorkOrders/{plannedDate}";
        if (plannedDate === undefined || plannedDate === null)
            throw new Error("The parameter 'plannedDate' must be defined.");
        url_ = url_.replace("{plannedDate}", encodeURIComponent(plannedDate ? "" + plannedDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkOrders(_response);
        });
    }

    protected processGetWorkOrders(response: Response): Promise<ResultOfAPIResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAPIResponseModel>(null as any);
    }

    /**
     * Gets All Permits to work with information
     * @return The list of entities
     */
    getPermitsToWork(query: GetPermitsToWorkQuery, signal?: AbortSignal | undefined): Promise<ResultOfAPIResponseModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetPermitsToWork";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermitsToWork(_response);
        });
    }

    protected processGetPermitsToWork(response: Response): Promise<ResultOfAPIResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAPIResponseModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAPIResponseModel>(null as any);
    }

    /**
     * Calculate collisions
     * @return The list of entities
     */
    calculateCollisions(command: CalculateCollisionsCommand, signal?: AbortSignal | undefined): Promise<ResultOfIReadOnlyCollectionOfCollisionResponseModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/CalculateCollisions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateCollisions(_response);
        });
    }

    protected processCalculateCollisions(response: Response): Promise<ResultOfIReadOnlyCollectionOfCollisionResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionResponseModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIReadOnlyCollectionOfCollisionResponseModel>(null as any);
    }

    /**
     * Calculate collisions with equipments
     * @return The list of entities
     */
    calculateCollisionsWithEquipments(command: CalculateCollisionsWithEquipmentCommand, signal?: AbortSignal | undefined): Promise<ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/CalculateCollisionsWithEquipments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateCollisionsWithEquipments(_response);
        });
    }

    protected processCalculateCollisionsWithEquipments(response: Response): Promise<ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel>(null as any);
    }

    /**
     * Gets All Assets Power BI Reports
     * @return The list of entities
     */
    getAssetsPowerBIReports(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfAssetsPowerBIReportsModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetsPowerBIReports/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsPowerBIReports(_response);
        });
    }

    protected processGetAssetsPowerBIReports(response: Response): Promise<ResultOfAssetsPowerBIReportsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsPowerBIReportsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAssetsPowerBIReportsModel>(null as any);
    }

    /**
     * Add Assets Power BI Reports
     * @return Status
     */
    addAssetsPowerBIReports(command: AddAssetsPowerBIReportsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetsInformation/AddAssetsPowerBIReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAssetsPowerBIReports(_response);
        });
    }

    protected processAddAssetsPowerBIReports(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete Assets Power BI Reports
     * @return Status
     */
    deleteAssetsPowerBIReports(command: DeleteAssetsPowerBIReportsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/AssetsInformation/DeleteAssetsPowerBIReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAssetsPowerBIReports(_response);
        });
    }

    protected processDeleteAssetsPowerBIReports(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Heat Map
     * @return The list of entities
     */
    getHeatMap(projectId: string | null, date: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetHeatMap/{projectId}/{date}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeatMap(_response);
        });
    }

    protected processGetHeatMap(response: Response): Promise<ResultOfListOfAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAssetInformationModel>(null as any);
    }

    /**
     * Get Dates with heat map measurements
     * @return The list of entities
     */
    getDatesWithMeasurements(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfString> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetDatesWithMeasurements/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDatesWithMeasurements(_response);
        });
    }

    protected processGetDatesWithMeasurements(response: Response): Promise<ResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfString>(null as any);
    }

    /**
     * Get Months with heat map measurements
     * @return The list of entities
     */
    getMonthsWithMeasurements(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfString> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetMonthsWithMeasurements/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonthsWithMeasurements(_response);
        });
    }

    protected processGetMonthsWithMeasurements(response: Response): Promise<ResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfString>(null as any);
    }

    /**
     * Get Heat Map By Month
     * @return The list of entities
     */
    getHeatMapByMonth(projectId: string | null, year: string | null, month: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetHeatMapByMonth/{projectId}/{year}/{month}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeatMapByMonth(_response);
        });
    }

    protected processGetHeatMapByMonth(response: Response): Promise<ResultOfListOfAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAssetInformationModel>(null as any);
    }

    /**
     * Gets Assets With Documents
     * @param projectId (optional) 
     * @return The entity
     */
    getAssetsWithDocuments(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfAssetsWithDocuments> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetsWithDocuments?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsWithDocuments(_response);
        });
    }

    protected processGetAssetsWithDocuments(response: Response): Promise<ResultOfAssetsWithDocuments> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetsWithDocuments;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAssetsWithDocuments>(null as any);
    }

    /**
     * Gets Assets For DbIds
     * @param projectId (optional) 
     * @param dbId (optional) 
     * @return The entity
     */
    getAssetsForDbid(projectId: string | null | undefined, dbId: number | undefined, signal?: AbortSignal | undefined): Promise<ResultOfGetAssetsForDbidModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAssetsForDbid?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (dbId === null)
            throw new Error("The parameter 'dbId' cannot be null.");
        else if (dbId !== undefined)
            url_ += "dbId=" + encodeURIComponent("" + dbId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsForDbid(_response);
        });
    }

    protected processGetAssetsForDbid(response: Response): Promise<ResultOfGetAssetsForDbidModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsForDbidModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetAssetsForDbidModel>(null as any);
    }

    /**
     * Get All Categories
     * @return The entity
     */
    getAllCategories(query: GetAllCategoriesQuery, signal?: AbortSignal | undefined): Promise<ResultOfFullAssetInformationModel> {
        let url_ = this.baseUrl + "/api/AssetsInformation/GetAllCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCategories(_response);
        });
    }

    protected processGetAllCategories(response: Response): Promise<ResultOfFullAssetInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfFullAssetInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfFullAssetInformationModel>(null as any);
    }
}

export class ChatService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create Thread
     * @return OK
     */
    createThread(command: CreateThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/CreateThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateThread(_response);
        });
    }

    protected processCreateThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete Thread
     * @return OK
     */
    deleteThread(command: DeleteThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/DeleteThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteThread(_response);
        });
    }

    protected processDeleteThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Threads
     * @return OK
     */
    getThreads(query: GetThreadsQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetThreadsOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetThreads";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetThreads(_response);
        });
    }

    protected processGetThreads(response: Response): Promise<ResultOfGetThreadsOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetThreadsOutputModel>(null as any);
    }

    /**
     * Send Message
     * @param projectId (optional) 
     * @param threadId (optional) 
     * @param message (optional) 
     * @param assetId (optional) 
     * @param assetTag (optional) 
     * @param fileToUpload (optional) 
     * @return OK
     */
    sendMessage(projectId: string | null | undefined, threadId: string | null | undefined, message: string | null | undefined, assetId: string | null | undefined, assetTag: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/SendMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (threadId !== null && threadId !== undefined)
            content_.append("ThreadId", threadId.toString());
        if (message !== null && message !== undefined)
            content_.append("Message", message.toString());
        if (assetId !== null && assetId !== undefined)
            content_.append("AssetId", assetId.toString());
        if (assetTag !== null && assetTag !== undefined)
            content_.append("AssetTag", assetTag.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Edit Message
     * @return OK
     */
    editMessage(command: EditMessageCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/EditMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditMessage(_response);
        });
    }

    protected processEditMessage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete Message
     * @return OK
     */
    deleteMessage(command: DeleteMessageCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/DeleteMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMessage(_response);
        });
    }

    protected processDeleteMessage(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Messages
     * @return OK
     */
    getMessages(query: GetMessagesQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetMessagesOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: Response): Promise<ResultOfGetMessagesOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetMessagesOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetMessagesOutputModel>(null as any);
    }

    /**
     * Insert Read Messages
     * @return OK
     */
    insertReadMessages(command: InsertReadMessagesCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/InsertReadMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertReadMessages(_response);
        });
    }

    protected processInsertReadMessages(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Read Messages
     * @return OK
     */
    getReadMessages(query: GetReadMessagesQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetReadMessagesOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetReadMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReadMessages(_response);
        });
    }

    protected processGetReadMessages(response: Response): Promise<ResultOfGetReadMessagesOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetReadMessagesOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetReadMessagesOutputModel>(null as any);
    }

    /**
     * Add Thread Subscription
     * @return OK
     */
    addThreadSubscription(command: AddThreadSubscriptionCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/AddThreadSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddThreadSubscription(_response);
        });
    }

    protected processAddThreadSubscription(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete Thread Subscription
     * @return OK
     */
    deleteThreadSubscription(command: DeleteThreadSubscriptionCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/DeleteThreadSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteThreadSubscription(_response);
        });
    }

    protected processDeleteThreadSubscription(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Thread Subscriptions By User
     * @return OK
     */
    getThreadSubscriptionsByUser(query: GetThreadSubscriptionsByUserQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetThreadSubscriptionsByUserOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetThreadSubscriptionsByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetThreadSubscriptionsByUser(_response);
        });
    }

    protected processGetThreadSubscriptionsByUser(response: Response): Promise<ResultOfGetThreadSubscriptionsByUserOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadSubscriptionsByUserOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetThreadSubscriptionsByUserOutputModel>(null as any);
    }

    /**
     * Add User Access Thread
     * @return OK
     */
    addUserAccessThread(command: AddUserAccessThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/AddUserAccessThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserAccessThread(_response);
        });
    }

    protected processAddUserAccessThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Delete User Access Thread
     * @return OK
     */
    deleteUserAccessThread(command: DeleteUserAccessThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/DeleteUserAccessThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserAccessThread(_response);
        });
    }

    protected processDeleteUserAccessThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get User Access Thread
     * @return OK
     */
    getUserAccessThread(query: GetUserAccessThreadQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetUserAccessThreadOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetUserAccessThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAccessThread(_response);
        });
    }

    protected processGetUserAccessThread(response: Response): Promise<ResultOfGetUserAccessThreadOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUserAccessThreadOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetUserAccessThreadOutputModel>(null as any);
    }

    /**
     * Edit Thread
     * @return OK
     */
    editThread(command: EditThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/EditThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditThread(_response);
        });
    }

    protected processEditThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Restore Thread
     * @return OK
     */
    restoreThread(command: RestoreThreadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Chat/RestoreThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRestoreThread(_response);
        });
    }

    protected processRestoreThread(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Threads Count Subscriptions By User
     * @return OK
     */
    getThreadsCountSubscriptionsByUser(query: GetThreadsCountSubscriptionsByUserQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetThreadsCountSubscriptionsByUserOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetThreadsCountSubscriptionsByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetThreadsCountSubscriptionsByUser(_response);
        });
    }

    protected processGetThreadsCountSubscriptionsByUser(response: Response): Promise<ResultOfGetThreadsCountSubscriptionsByUserOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetThreadsCountSubscriptionsByUserOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetThreadsCountSubscriptionsByUserOutputModel>(null as any);
    }

    /**
     * GetUnreadMessagesByThread
     * @return OK
     */
    getUnreadMessagesByThread(query: GetUnreadMessagesByThreadQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetUnreadMessagesByThreadOutputModel> {
        let url_ = this.baseUrl + "/api/Chat/GetUnreadMessagesByThread";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadMessagesByThread(_response);
        });
    }

    protected processGetUnreadMessagesByThread(response: Response): Promise<ResultOfGetUnreadMessagesByThreadOutputModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetUnreadMessagesByThreadOutputModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetUnreadMessagesByThreadOutputModel>(null as any);
    }
}

export class DocumentationService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all documentation managers
     * @return The related resources
     */
    getConnectors(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfDocumentManagerDto> {
        let url_ = this.baseUrl + "/api/Documentation/GetConnectors/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnectors(_response);
        });
    }

    protected processGetConnectors(response: Response): Promise<ResultOfIListOfDocumentManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfDocumentManagerDto>(null as any);
    }

    /**
     * Gets the documentation manager
     * @return The related resources
     */
    getConnector(connectorId: string | null, projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfDocumentManagerFullDto> {
        let url_ = this.baseUrl + "/api/Documentation/GetConnector/{connectorId}/{projectId}";
        if (connectorId === undefined || connectorId === null)
            throw new Error("The parameter 'connectorId' must be defined.");
        url_ = url_.replace("{connectorId}", encodeURIComponent("" + connectorId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnector(_response);
        });
    }

    protected processGetConnector(response: Response): Promise<ResultOfDocumentManagerFullDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerFullDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentManagerFullDto>(null as any);
    }

    /**
     * Creates a new documentation manager
     * @return Created
     */
    createConnector(command: CreateDocumentationManagerCommand, signal?: AbortSignal | undefined): Promise<ResultOfDocumentManagerDto> {
        let url_ = this.baseUrl + "/api/Documentation/CreateConnector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateConnector(_response);
        });
    }

    protected processCreateConnector(response: Response): Promise<ResultOfDocumentManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentManagerDto>(null as any);
    }

    /**
     * Edits the documentation manager entity by Id
     * @return Ok
     */
    editConnector(command: EditDocumentationManagerCommand, signal?: AbortSignal | undefined): Promise<ResultOfDocumentManagerDto> {
        let url_ = this.baseUrl + "/api/Documentation/EditConnector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditConnector(_response);
        });
    }

    protected processEditConnector(response: Response): Promise<ResultOfDocumentManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentManagerDto>(null as any);
    }

    /**
     * Gets all element documents in a path using a connector
     * @return The documents associated
     */
    getAllDocumentationElementsByPath(query: GetDocumentElementsByPathQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfDocumentationElementVm> {
        let url_ = this.baseUrl + "/api/Documentation/GetAllDocumentationElementsByPath";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDocumentationElementsByPath(_response);
        });
    }

    protected processGetAllDocumentationElementsByPath(response: Response): Promise<ResultOfListOfDocumentationElementVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationElementVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfDocumentationElementVm>(null as any);
    }

    /**
     * Gets all documents
     * @return The related resources
     */
    getAllDocuments(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfDocumentDto> {
        let url_ = this.baseUrl + "/api/Documentation/GetAllDocuments/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllDocuments(_response);
        });
    }

    protected processGetAllDocuments(response: Response): Promise<ResultOfIListOfDocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfDocumentDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfDocumentDto>(null as any);
    }

    /**
     * Downloads a document
     * @return Document
     */
    downloadDocument(command: DownloadDocumentCommand, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documentation/DownloadDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addFiles(projectId: string | null | undefined, tags: string | null | undefined, files: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/AddFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (tags !== null && tags !== undefined)
            content_.append("Tags", tags.toString());
        if (files !== null && files !== undefined)
            content_.append("Files", files.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddFiles(_response);
        });
    }

    protected processAddFiles(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    overwriteFile(projectId: string | null | undefined, id: string | null | undefined, name: string | null | undefined, type: string | null | undefined, tags: string[] | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/Documentation/OverwriteFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (id !== null && id !== undefined)
            content_.append("Id", id.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (type !== null && type !== undefined)
            content_.append("Type", type.toString());
        if (tags !== null && tags !== undefined)
            tags.forEach(item_ => content_.append("Tags", item_.toString()));
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOverwriteFile(_response);
        });
    }

    protected processOverwriteFile(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    checkIfDocumentExist(projectId: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfDocumentAssetsModel> {
        let url_ = this.baseUrl + "/api/Documentation/CheckIfDocumentExist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckIfDocumentExist(_response);
        });
    }

    protected processCheckIfDocumentExist(response: Response): Promise<ResultOfDocumentAssetsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentAssetsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentAssetsModel>(null as any);
    }

    updateFileTag(command: UpdateFileTagsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/UpdateFileTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileTag(_response);
        });
    }

    protected processUpdateFileTag(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    deleteFileTag(command: DeleteFileTagsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/DeleteFileTag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFileTag(_response);
        });
    }

    protected processDeleteFileTag(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    deleteInDocumentsAnAsset(command: DeleteInDocumentsAnAssetCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/DeleteInDocumentsAnAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInDocumentsAnAsset(_response);
        });
    }

    protected processDeleteInDocumentsAnAsset(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Download documents
     * @return Document
     */
    downloadDocumentation(command: DownloadDocumentationCommand, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Documentation/DownloadDocumentation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocumentation(_response);
        });
    }

    protected processDownloadDocumentation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets the Documents By Tag
     * @return The docuemnts
     */
    getDocumentsByTag(projectId: string | null, tag: string | null, signal?: AbortSignal | undefined): Promise<ResultOfDocumentsAssetsApiResponse> {
        let url_ = this.baseUrl + "/api/Documentation/GetDocumentsByTag/{projectId}/{tag}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentsByTag(_response);
        });
    }

    protected processGetDocumentsByTag(response: Response): Promise<ResultOfDocumentsAssetsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentsAssetsApiResponse>(null as any);
    }

    /**
     * Gets the Documents
     * @param projectId (optional) 
     * @return The docuemnts
     */
    getAllProjectDocuments(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfDocumentsAssetsApiResponse> {
        let url_ = this.baseUrl + "/api/Documentation/GetAllProjectDocuments?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProjectDocuments(_response);
        });
    }

    protected processGetAllProjectDocuments(response: Response): Promise<ResultOfDocumentsAssetsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentsAssetsApiResponse>(null as any);
    }

    /**
     * Gets the Documents
     * @return The docuemnts
     */
    getDocumentsByTagApi(projectId: string | null, tag: string | null, signal?: AbortSignal | undefined): Promise<ResultOfDocumentsAssetsApiResponse> {
        let url_ = this.baseUrl + "/api/Documentation/GetDocumentsByTagApi/{projectId}/{tag}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentsByTagApi(_response);
        });
    }

    protected processGetDocumentsByTagApi(response: Response): Promise<ResultOfDocumentsAssetsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsAssetsApiResponse;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentsAssetsApiResponse>(null as any);
    }

    deleteFiles(command: DeleteFilesCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/DeleteFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFiles(_response);
        });
    }

    protected processDeleteFiles(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    deleteFolders(command: DeleteFoldersCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/DeleteFolders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFolders(_response);
        });
    }

    protected processDeleteFolders(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getDocumentsTree(projectId: string | null | undefined, assetTag: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfDocumentsTree> {
        let url_ = this.baseUrl + "/api/Documentation/GetDocumentsTree?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (assetTag !== undefined && assetTag !== null)
            url_ += "assetTag=" + encodeURIComponent("" + assetTag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentsTree(_response);
        });
    }

    protected processGetDocumentsTree(response: Response): Promise<ResultOfDocumentsTree> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentsTree>(null as any);
    }

    getFoldersTree(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfDocumentsTree> {
        let url_ = this.baseUrl + "/api/Documentation/GetFoldersTree?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFoldersTree(_response);
        });
    }

    protected processGetFoldersTree(response: Response): Promise<ResultOfDocumentsTree> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDocumentsTree;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDocumentsTree>(null as any);
    }

    createFolder(command: CreateFolderCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Documentation/CreateFolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getAssetsDocumentsRelations(query: GetAssetsDocumentsRelationsQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetAssetsDocumentsRelationsModel> {
        let url_ = this.baseUrl + "/api/Documentation/GetAssetsDocumentsRelations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetsDocumentsRelations(_response);
        });
    }

    protected processGetAssetsDocumentsRelations(response: Response): Promise<ResultOfGetAssetsDocumentsRelationsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetAssetsDocumentsRelationsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetAssetsDocumentsRelationsModel>(null as any);
    }
}

export class ForgeService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the Forge account related resources
     * @return The related resources
     */
    getForgeAccountRelatedResources(forgeAccountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfForgeAccountRelatedResourcesVm> {
        let url_ = this.baseUrl + "/api/Forge/GetForgeAccountRelatedResources/{forgeAccountId}";
        if (forgeAccountId === undefined || forgeAccountId === null)
            throw new Error("The parameter 'forgeAccountId' must be defined.");
        url_ = url_.replace("{forgeAccountId}", encodeURIComponent("" + forgeAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForgeAccountRelatedResources(_response);
        });
    }

    protected processGetForgeAccountRelatedResources(response: Response): Promise<ResultOfForgeAccountRelatedResourcesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountRelatedResourcesVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeAccountRelatedResourcesVm>(null as any);
    }

    /**
     * Gets all Forge Accounts
     * @return Ok
     */
    getAllAccounts(signal?: AbortSignal | undefined): Promise<ResultOfIListOfForgeAccountDto> {
        let url_ = this.baseUrl + "/api/Forge/GetAllAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAccounts(_response);
        });
    }

    protected processGetAllAccounts(response: Response): Promise<ResultOfIListOfForgeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeAccountDto;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfForgeAccountDto>(null as any);
    }

    /**
     * Gets a Forge account
     * @return Ok
     */
    getAccount(accountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfForgeAccountFullDto> {
        let url_ = this.baseUrl + "/api/Forge/GetAccount/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: Response): Promise<ResultOfForgeAccountFullDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountFullDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeAccountFullDto>(null as any);
    }

    /**
     * Creates a new Forge Account
     * @return Created
     */
    createForgeAccount(command: CreateForgeAccountCommand, signal?: AbortSignal | undefined): Promise<ResultOfForgeAccountDto> {
        let url_ = this.baseUrl + "/api/Forge/CreateForgeAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateForgeAccount(_response);
        });
    }

    protected processCreateForgeAccount(response: Response): Promise<ResultOfForgeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeAccountDto>(null as any);
    }

    /**
     * Updates a Forge Account
     * @return Ok
     */
    updateForgeAccount(command: UpdateForgeAccountCommand, signal?: AbortSignal | undefined): Promise<ResultOfForgeAccountDto> {
        let url_ = this.baseUrl + "/api/Forge/UpdateForgeAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateForgeAccount(_response);
        });
    }

    protected processUpdateForgeAccount(response: Response): Promise<ResultOfForgeAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeAccountDto>(null as any);
    }

    /**
     * Gets the Forge object related resources
     * @return The related resources
     */
    getForgeObjectRelatedResources(forgeObjectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfForgeObjectRelatedResourcesVm> {
        let url_ = this.baseUrl + "/api/Forge/GetForgeObjectRelatedResources/{forgeObjectId}";
        if (forgeObjectId === undefined || forgeObjectId === null)
            throw new Error("The parameter 'forgeObjectId' must be defined.");
        url_ = url_.replace("{forgeObjectId}", encodeURIComponent("" + forgeObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForgeObjectRelatedResources(_response);
        });
    }

    protected processGetForgeObjectRelatedResources(response: Response): Promise<ResultOfForgeObjectRelatedResourcesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectRelatedResourcesVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeObjectRelatedResourcesVm>(null as any);
    }

    /**
     * Gets the properties database from a model in SQLite format
     * @return The properties data base
     */
    getPropertiesDataBase(forgeObjectId: string | null, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Forge/GetPropertiesDataBase/{forgeObjectId}";
        if (forgeObjectId === undefined || forgeObjectId === null)
            throw new Error("The parameter 'forgeObjectId' must be defined.");
        url_ = url_.replace("{forgeObjectId}", encodeURIComponent("" + forgeObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertiesDataBase(_response);
        });
    }

    protected processGetPropertiesDataBase(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfLongDocumentResult;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfLongDocumentResult;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfLongDocumentResult;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfLongDocumentResult;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfLongDocumentResult;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Adds materials from a model in SQLite format
     * @return A data base of materials
     */
    addModelMaterials(command: AddModelMaterialsCommand, signal?: AbortSignal | undefined): Promise<ResultOfListOfForgeObjectMaterialDto> {
        let url_ = this.baseUrl + "/api/Forge/AddModelMaterials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddModelMaterials(_response);
        });
    }

    protected processAddModelMaterials(response: Response): Promise<ResultOfListOfForgeObjectMaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfForgeObjectMaterialDto>(null as any);
    }

    /**
     * Gets the materials from a model in SQLite format
     * @return The materials
     */
    getModelMaterials(forgeObjectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfForgeObjectMaterialDto> {
        let url_ = this.baseUrl + "/api/Forge/GetModelMaterials/{forgeObjectId}";
        if (forgeObjectId === undefined || forgeObjectId === null)
            throw new Error("The parameter 'forgeObjectId' must be defined.");
        url_ = url_.replace("{forgeObjectId}", encodeURIComponent("" + forgeObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelMaterials(_response);
        });
    }

    protected processGetModelMaterials(response: Response): Promise<ResultOfListOfForgeObjectMaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfForgeObjectMaterialDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfForgeObjectMaterialDto>(null as any);
    }

    /**
     * Gets the Autodesk Forge Public Token
     * @return The public token
     */
    getPublicToken(forgeAccountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfForgePublicTokenVm> {
        let url_ = this.baseUrl + "/api/Forge/GetPublicToken/{forgeAccountId}";
        if (forgeAccountId === undefined || forgeAccountId === null)
            throw new Error("The parameter 'forgeAccountId' must be defined.");
        url_ = url_.replace("{forgeAccountId}", encodeURIComponent("" + forgeAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPublicToken(_response);
        });
    }

    protected processGetPublicToken(response: Response): Promise<ResultOfForgePublicTokenVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgePublicTokenVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgePublicTokenVm>(null as any);
    }

    /**
     * Method to obtain the bucket objects list
     * @return The bucket objects
     */
    getBucketObjects(forgeAccountId: string | null, bucketKey: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfBucketObjectVm> {
        let url_ = this.baseUrl + "/api/Forge/GetBucketObjects/{forgeAccountId}/{bucketKey}";
        if (forgeAccountId === undefined || forgeAccountId === null)
            throw new Error("The parameter 'forgeAccountId' must be defined.");
        url_ = url_.replace("{forgeAccountId}", encodeURIComponent("" + forgeAccountId));
        if (bucketKey === undefined || bucketKey === null)
            throw new Error("The parameter 'bucketKey' must be defined.");
        url_ = url_.replace("{bucketKey}", encodeURIComponent("" + bucketKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBucketObjects(_response);
        });
    }

    protected processGetBucketObjects(response: Response): Promise<ResultOfListOfBucketObjectVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfBucketObjectVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfBucketObjectVm>(null as any);
    }

    /**
     * Method to obtain the Forge buckets account
     * @return The buckets list
     */
    getBuckets(forgeAccountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfString> {
        let url_ = this.baseUrl + "/api/Forge/GetBuckets/{forgeAccountId}";
        if (forgeAccountId === undefined || forgeAccountId === null)
            throw new Error("The parameter 'forgeAccountId' must be defined.");
        url_ = url_.replace("{forgeAccountId}", encodeURIComponent("" + forgeAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBuckets(_response);
        });
    }

    protected processGetBuckets(response: Response): Promise<ResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfString>(null as any);
    }

    /**
     * Creates a new bucket
     * @return Entity created
     */
    createBucket(command: CreateBucketCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Forge/CreateBucket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBucket(_response);
        });
    }

    protected processCreateBucket(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Uploads a new forge object to an existing Bucket
     * @param bucketId (optional) 
     * @param forgeAccountId (optional) 
     * @param object (optional) 
     * @return Request ok
     */
    uploadObject(bucketId: string | null | undefined, forgeAccountId: string | null | undefined, object: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Forge/UploadObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (bucketId !== null && bucketId !== undefined)
            content_.append("BucketId", bucketId.toString());
        if (forgeAccountId !== null && forgeAccountId !== undefined)
            content_.append("ForgeAccountId", forgeAccountId.toString());
        if (object !== null && object !== undefined)
            content_.append("Object", object.data, object.fileName ? object.fileName : "Object");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadObject(_response);
        });
    }

    protected processUploadObject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Converts a Forge Object to a derivative model
     * @return Request accepted
     */
    translateObject(command: TranslateObjectCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Forge/TranslateObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTranslateObject(_response);
        });
    }

    protected processTranslateObject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Import a existing 3D model on Forge to bdt_config
     * @return An accepted response
     */
    importObject(command: ImportObjectCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Forge/ImportObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportObject(_response);
        });
    }

    protected processImportObject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class HeatmapService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    sendHeatmap(heatmaps: SendHeatmapInput, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Heatmap/SendHeatmap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(heatmaps);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendHeatmap(_response);
        });
    }

    protected processSendHeatmap(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class IdentityService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all teams
     * @return Ok
     */
    getTeams(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfTeamDto> {
        let url_ = this.baseUrl + "/api/Identity/GetTeams/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeams(_response);
        });
    }

    protected processGetTeams(response: Response): Promise<ResultOfIListOfTeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfTeamDto;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfTeamDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfTeamDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfTeamDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfTeamDto>(null as any);
    }

    /**
     * Gets a team
     * @return Ok
     */
    getTeam(teamId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfTeamDto> {
        let url_ = this.baseUrl + "/api/Identity/GetTeam/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeam(_response);
        });
    }

    protected processGetTeam(response: Response): Promise<ResultOfTeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfTeamDto>(null as any);
    }

    /**
     * Gets the team related resources
     * @return The related resources
     */
    getTeamRelatedResources(teamId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfTeamRelatedResourcesVm> {
        let url_ = this.baseUrl + "/api/Identity/GetTeamRelatedResources/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTeamRelatedResources(_response);
        });
    }

    protected processGetTeamRelatedResources(response: Response): Promise<ResultOfTeamRelatedResourcesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamRelatedResourcesVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfTeamRelatedResourcesVm>(null as any);
    }

    /**
     * Creates a new team
     * @return Created
     */
    createTeam(command: CreateTeamCommand, signal?: AbortSignal | undefined): Promise<ResultOfTeamDto> {
        let url_ = this.baseUrl + "/api/Identity/CreateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTeam(_response);
        });
    }

    protected processCreateTeam(response: Response): Promise<ResultOfTeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfTeamDto>(null as any);
    }

    /**
     * Updates a team
     * @return Ok
     */
    updateTeam(command: UpdateTeamCommand, signal?: AbortSignal | undefined): Promise<ResultOfTeamDto> {
        let url_ = this.baseUrl + "/api/Identity/UpdateTeam";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTeam(_response);
        });
    }

    protected processUpdateTeam(response: Response): Promise<ResultOfTeamDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfTeamDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfTeamDto>(null as any);
    }

    /**
     * Deletes a team
     * @return Ok
     */
    deleteTeam(teamId: string | null, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Identity/DeleteTeam/{teamId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTeam(_response);
        });
    }

    protected processDeleteTeam(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class KBEquipmentContextService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add new knowledge base equipment context path
     * @return The new entity
     */
    addKnowledgeBaseEquipmentContext(command: AddKnowledgeBaseEquipmentContextCommand, signal?: AbortSignal | undefined): Promise<ResultOfKBEquipmentContextDto> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/AddKnowledgeBaseEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddKnowledgeBaseEquipmentContext(_response);
        });
    }

    protected processAddKnowledgeBaseEquipmentContext(response: Response): Promise<ResultOfKBEquipmentContextDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfKBEquipmentContextDto>(null as any);
    }

    /**
     * Update new knowledge base equipment context path
     * @return The new entity
     */
    updateKnowledgeBaseEquipmentContext(command: UpdateKnowledgeBaseEquipmentContextCommand, signal?: AbortSignal | undefined): Promise<ResultOfKBEquipmentContextDto> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/UpdateKnowledgeBaseEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateKnowledgeBaseEquipmentContext(_response);
        });
    }

    protected processUpdateKnowledgeBaseEquipmentContext(response: Response): Promise<ResultOfKBEquipmentContextDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfKBEquipmentContextDto>(null as any);
    }

    /**
     * Upload file to specific knowledge base equipment context
     * @param kBEquipmentContextId (optional) 
     * @param projectId (optional) 
     * @param assetName (optional) 
     * @param fileToUpload (optional) 
     */
    uploadFileKBEquipmentContext(kBEquipmentContextId: string | null | undefined, projectId: string | null | undefined, assetName: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/UploadFileKBEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (kBEquipmentContextId !== null && kBEquipmentContextId !== undefined)
            content_.append("KBEquipmentContextId", kBEquipmentContextId.toString());
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (assetName !== null && assetName !== undefined)
            content_.append("AssetName", assetName.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFileKBEquipmentContext(_response);
        });
    }

    protected processUploadFileKBEquipmentContext(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Download file to specific knowledge base equipment context
     */
    downloadKBEquipmentContext(command: DownloadKBEquipmentContextCommand, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/DownloadKBEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadKBEquipmentContext(_response);
        });
    }

    protected processDownloadKBEquipmentContext(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets all knowledge base equipment context
     * @return List of knowledge base equipment context
     */
    getAllKnowledgeBaseEquipmentContext(signal?: AbortSignal | undefined): Promise<ResultOfIListOfKBEquipmentContextDto> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/GetAllKnowledgeBaseEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllKnowledgeBaseEquipmentContext(_response);
        });
    }

    protected processGetAllKnowledgeBaseEquipmentContext(response: Response): Promise<ResultOfIListOfKBEquipmentContextDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfKBEquipmentContextDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfKBEquipmentContextDto>(null as any);
    }

    /**
     * Get asset knowledge base equipment context resources
     * @return List of resources permissions
     */
    getAssetKnowledgeBaseEquipmentContext(query: GetAssetKnowledgeBaseEquipmentContextQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfDocumentationVm> {
        let url_ = this.baseUrl + "/api/KBEquipmentContext/GetAssetKnowledgeBaseEquipmentContext";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetKnowledgeBaseEquipmentContext(_response);
        });
    }

    protected processGetAssetKnowledgeBaseEquipmentContext(response: Response): Promise<ResultOfListOfDocumentationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfDocumentationVm;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfDocumentationVm>(null as any);
    }
}

export class MonitoringService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Creates a new permissions
     * @return Created
     */
    addMonitoringManagerPermissions(command: AddProjectResourcePermissionVm, signal?: AbortSignal | undefined): Promise<ResultOfPermissionsOperationVm> {
        let url_ = this.baseUrl + "/api/Monitoring/AddMonitoringManagerPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMonitoringManagerPermissions(_response);
        });
    }

    protected processAddMonitoringManagerPermissions(response: Response): Promise<ResultOfPermissionsOperationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPermissionsOperationVm>(null as any);
    }

    /**
     * Updates permissions
     * @return Created
     */
    updateMonitoringManagerPermissions(command: UpdateProjectResourcePermissionVm, signal?: AbortSignal | undefined): Promise<ResultOfPermissionsOperationVm> {
        let url_ = this.baseUrl + "/api/Monitoring/UpdateMonitoringManagerPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMonitoringManagerPermissions(_response);
        });
    }

    protected processUpdateMonitoringManagerPermissions(response: Response): Promise<ResultOfPermissionsOperationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPermissionsOperationVm>(null as any);
    }

    /**
     * Remove permissions
     * @return Created
     */
    removeMonitoringManagerPermissions(command: RemoveProjectResourcePermissionVm, signal?: AbortSignal | undefined): Promise<ResultOfPermissionsOperationVm> {
        let url_ = this.baseUrl + "/api/Monitoring/RemoveMonitoringManagerPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveMonitoringManagerPermissions(_response);
        });
    }

    protected processRemoveMonitoringManagerPermissions(response: Response): Promise<ResultOfPermissionsOperationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPermissionsOperationVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPermissionsOperationVm>(null as any);
    }

    /**
     * Gets the resource permissions
     * @param resourceId Resource Id
     * @return The related resources
     */
    getMonitoringManagerPermissionsById(resourceId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectResourcePermissionsVm> {
        let url_ = this.baseUrl + "/api/Monitoring/GetMonitoringManagerPermissionsById/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMonitoringManagerPermissionsById(_response);
        });
    }

    protected processGetMonitoringManagerPermissionsById(response: Response): Promise<ResultOfProjectResourcePermissionsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectResourcePermissionsVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectResourcePermissionsVm>(null as any);
    }

    /**
     * Creates a new monitoring manager
     * @return Created
     */
    createConnector(command: CreateMonitoringManagerCommand, signal?: AbortSignal | undefined): Promise<ResultOfMonitoringManagerDto> {
        let url_ = this.baseUrl + "/api/Monitoring/CreateConnector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateConnector(_response);
        });
    }

    protected processCreateConnector(response: Response): Promise<ResultOfMonitoringManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfMonitoringManagerDto>(null as any);
    }

    /**
     * Edits the monitoring manager entity by Id
     * @return Ok
     */
    editConnector(command: EditMonitoringManagerCommand, signal?: AbortSignal | undefined): Promise<ResultOfMonitoringManagerDto> {
        let url_ = this.baseUrl + "/api/Monitoring/EditConnector";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditConnector(_response);
        });
    }

    protected processEditConnector(response: Response): Promise<ResultOfMonitoringManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfMonitoringManagerDto>(null as any);
    }

    /**
     * Deletes the monitoring manager entity by Id
     * @return Ok
     */
    deleteConnector(connectorId: string | null, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Monitoring/DeleteConnector/{connectorId}";
        if (connectorId === undefined || connectorId === null)
            throw new Error("The parameter 'connectorId' must be defined.");
        url_ = url_.replace("{connectorId}", encodeURIComponent("" + connectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteConnector(_response);
        });
    }

    protected processDeleteConnector(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Gets all monitring managers
     * @return Ok
     */
    getConnectors(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfMonitoringManagerDto> {
        let url_ = this.baseUrl + "/api/Monitoring/GetConnectors/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnectors(_response);
        });
    }

    protected processGetConnectors(response: Response): Promise<ResultOfIListOfMonitoringManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfMonitoringManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfMonitoringManagerDto>(null as any);
    }

    /**
     * Gets the monitoring manager
     * @return Ok
     */
    getConnector(connectorId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfMonitoringManagerDto> {
        let url_ = this.baseUrl + "/api/Monitoring/GetConnector/{connectorId}";
        if (connectorId === undefined || connectorId === null)
            throw new Error("The parameter 'connectorId' must be defined.");
        url_ = url_.replace("{connectorId}", encodeURIComponent("" + connectorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConnector(_response);
        });
    }

    protected processGetConnector(response: Response): Promise<ResultOfMonitoringManagerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfMonitoringManagerDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfMonitoringManagerDto>(null as any);
    }
}

export class NotificationsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Mark as read a notification
     * @return The related resources
     */
    markAsRead(command: MarkAsReadCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Notifications/MarkAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMarkAsRead(_response);
        });
    }

    protected processMarkAsRead(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Return a list of all current user notifications read and not read
     * @param projectId (optional) 
     * @return The related resources
     */
    getAllNotificationsByUser(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfListOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/Notifications/GetAllNotificationsByUserQuery?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllNotificationsByUser(_response);
        });
    }

    protected processGetAllNotificationsByUser(response: Response): Promise<ResultOfListOfUserNotificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfUserNotificationDto>(null as any);
    }

    /**
     * Return a list of all current user notifications
     * @param projectId (optional) 
     * @return The related resources
     */
    getUnreadNotifications(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfListOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/Notifications/GetUnreadNotificationsQuery?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadNotifications(_response);
        });
    }

    protected processGetUnreadNotifications(response: Response): Promise<ResultOfListOfUserNotificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfUserNotificationDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfUserNotificationDto>(null as any);
    }

    /**
     * Return a list of all unread current user notifications
     * @param projectId (optional) 
     * @return The related resources
     */
    getUnreadNotificationsCount(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfNotificationsNumberVm> {
        let url_ = this.baseUrl + "/api/Notifications/GetUnreadNotificationsCount?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnreadNotificationsCount(_response);
        });
    }

    protected processGetUnreadNotificationsCount(response: Response): Promise<ResultOfNotificationsNumberVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfNotificationsNumberVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfNotificationsNumberVm>(null as any);
    }
}

export class PowerAppsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the Power App objects
     * @return Ok
     */
    getPowerApps(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfProjectPowerAppObjectDto> {
        let url_ = this.baseUrl + "/api/PowerApps/GetPowerApps/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerApps(_response);
        });
    }

    protected processGetPowerApps(response: Response): Promise<ResultOfIListOfProjectPowerAppObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerAppObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfProjectPowerAppObjectDto>(null as any);
    }

    /**
     * Add Power Apps to project
     * @return Created
     */
    addPowerApps(command: AddPowerAppsCommand, signal?: AbortSignal | undefined): Promise<ResultOfListOfProjectPowerAppObjectDto> {
        let url_ = this.baseUrl + "/api/PowerApps/AddPowerApps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPowerApps(_response);
        });
    }

    protected processAddPowerApps(response: Response): Promise<ResultOfListOfProjectPowerAppObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerAppObjectDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerAppObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerAppObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerAppObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerAppObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfProjectPowerAppObjectDto>(null as any);
    }

    /**
     * Deletes the Power App
     * @return Ok
     */
    deletePowerApp(id: string | null, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerApps/DeletePowerApp/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerApp(_response);
        });
    }

    protected processDeletePowerApp(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Deletes the Power Apps
     * @return Ok
     */
    deletePowerApps(command: DeletePowerAppsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerApps/DeletePowerApps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerApps(_response);
        });
    }

    protected processDeletePowerApps(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class PowerBIService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all Power BI Accounts
     * @return Ok
     */
    getAllAccounts(signal?: AbortSignal | undefined): Promise<ResultOfIListOfPowerBIAccountDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetAllAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllAccounts(_response);
        });
    }

    protected processGetAllAccounts(response: Response): Promise<ResultOfIListOfPowerBIAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfPowerBIAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfPowerBIAccountDto>(null as any);
    }

    /**
     * Gets a Power BI account
     * @return Ok
     */
    getAccount(accountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfPowerBIAccountDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetAccount/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccount(_response);
        });
    }

    protected processGetAccount(response: Response): Promise<ResultOfPowerBIAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPowerBIAccountDto>(null as any);
    }

    /**
     * Creates a new Power BI Account
     * @return Created
     */
    createPowerBIAccount(command: CreatePowerBIAccountCommand, signal?: AbortSignal | undefined): Promise<ResultOfPowerBIAccountDto> {
        let url_ = this.baseUrl + "/api/PowerBI/CreatePowerBIAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePowerBIAccount(_response);
        });
    }

    protected processCreatePowerBIAccount(response: Response): Promise<ResultOfPowerBIAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPowerBIAccountDto>(null as any);
    }

    /**
     * Updates a Power BI Account
     * @return Ok
     */
    updatePowerBIAccount(command: UpdatePowerBIAccountCommand, signal?: AbortSignal | undefined): Promise<ResultOfPowerBIAccountDto> {
        let url_ = this.baseUrl + "/api/PowerBI/UpdatePowerBIAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePowerBIAccount(_response);
        });
    }

    protected processUpdatePowerBIAccount(response: Response): Promise<ResultOfPowerBIAccountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfPowerBIAccountDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfPowerBIAccountDto>(null as any);
    }

    /**
     * Deletes a Power BI Account
     * @return Ok
     */
    deletePowerBIAccount(accountId: string | null, forceDelete: boolean, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerBI/DeletePowerBIAccount/{accountId}/{forceDelete}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (forceDelete === undefined || forceDelete === null)
            throw new Error("The parameter 'forceDelete' must be defined.");
        url_ = url_.replace("{forceDelete}", encodeURIComponent("" + forceDelete));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerBIAccount(_response);
        });
    }

    protected processDeletePowerBIAccount(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Gets a Power BI workspaces
     * @return Ok
     */
    getWorkspaces(accountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfListOfPowerBIWorkspaceVm> {
        let url_ = this.baseUrl + "/api/PowerBI/GetWorkspaces/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkspaces(_response);
        });
    }

    protected processGetWorkspaces(response: Response): Promise<ResultOfListOfPowerBIWorkspaceVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfPowerBIWorkspaceVm>(null as any);
    }

    /**
     * Gets a Power BI workspace objects
     * @param workspaceId (optional) 
     * @return Ok
     */
    getWorkspaceObjects(accountId: string | null, workspaceId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfListOfPowerBIWorkspaceObjectVm> {
        let url_ = this.baseUrl + "/api/PowerBI/GetWorkspaceObjects/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (workspaceId !== undefined && workspaceId !== null)
            url_ += "workspaceId=" + encodeURIComponent("" + workspaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkspaceObjects(_response);
        });
    }

    protected processGetWorkspaceObjects(response: Response): Promise<ResultOfListOfPowerBIWorkspaceObjectVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIWorkspaceObjectVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfPowerBIWorkspaceObjectVm>(null as any);
    }

    /**
     * Gets a Power BI Account Access Token
     * @return Ok
     */
    getAccessToken(accountId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/PowerBI/GetAccessToken/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessToken(_response);
        });
    }

    protected processGetAccessToken(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    /**
     * Add Power BI Objects Model configurations
     * @return Created
     */
    addPowerBIObjectsModelConfiguration(command: AddPowerBIObjectsModelConfigurationCommand, signal?: AbortSignal | undefined): Promise<ResultOfListOfPowerBIObjectModelConfigurationDto> {
        let url_ = this.baseUrl + "/api/PowerBI/AddPowerBIObjectsModelConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPowerBIObjectsModelConfiguration(_response);
        });
    }

    protected processAddPowerBIObjectsModelConfiguration(response: Response): Promise<ResultOfListOfPowerBIObjectModelConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIObjectModelConfigurationDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIObjectModelConfigurationDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIObjectModelConfigurationDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIObjectModelConfigurationDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfPowerBIObjectModelConfigurationDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfPowerBIObjectModelConfigurationDto>(null as any);
    }

    /**
     * Assing Power BI Objects to project
     * @return Created
     */
    assignPowerBIObjects(command: AssingPowerBIObjectsCommand, signal?: AbortSignal | undefined): Promise<ResultOfListOfProjectPowerBIObjectDto> {
        let url_ = this.baseUrl + "/api/PowerBI/AssignPowerBIObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignPowerBIObjects(_response);
        });
    }

    protected processAssignPowerBIObjects(response: Response): Promise<ResultOfListOfProjectPowerBIObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerBIObjectDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerBIObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerBIObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerBIObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfProjectPowerBIObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfProjectPowerBIObjectDto>(null as any);
    }

    /**
     * Deletes the Power BI object
     * @return Ok
     */
    deletePowerBIObject(projectId: string | null, id: string | null, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerBI/DeletePowerBIObject/{projectId}/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerBIObject(_response);
        });
    }

    protected processDeletePowerBIObject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Deletes the Power BI object
     * @return Ok
     */
    deletePowerBIObjects(command: DeletePowerBIObjectsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerBI/DeletePowerBIObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerBIObjects(_response);
        });
    }

    protected processDeletePowerBIObjects(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Deletes the Power BI object configurations
     * @return Ok
     */
    deletePowerBIObjectsConfiguration(command: DeletePowerBIObjectsConfigurationCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/PowerBI/DeletePowerBIObjectsConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePowerBIObjectsConfiguration(_response);
        });
    }

    protected processDeletePowerBIObjectsConfiguration(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get the Power BI objects
     * @return Ok
     */
    getPowerBIObjects(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetPowerBIObjects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerBIObjects(_response);
        });
    }

    protected processGetPowerBIObjects(response: Response): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfProjectPowerBIObjectDto>(null as any);
    }

    /**
     * Get the Power BI object
     * @return Ok
     */
    getPowerBIObject(id: string | null, projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectPowerBIObjectFullDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetPowerBIObject/{id}/{projectId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerBIObject(_response);
        });
    }

    protected processGetPowerBIObject(response: Response): Promise<ResultOfProjectPowerBIObjectFullDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectFullDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectPowerBIObjectFullDto>(null as any);
    }

    /**
     * Gets the Power BI objects report type
     * @return Ok
     */
    getPowerBIReports(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetPowerBIReports/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerBIReports(_response);
        });
    }

    protected processGetPowerBIReports(response: Response): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfProjectPowerBIObjectDto>(null as any);
    }

    /**
     * Gets the Power BI objects dashboard type
     * @return Ok
     */
    getPowerBIDashboards(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        let url_ = this.baseUrl + "/api/PowerBI/GetPowerBIDashboards/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerBIDashboards(_response);
        });
    }

    protected processGetPowerBIDashboards(response: Response): Promise<ResultOfIListOfProjectPowerBIObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectPowerBIObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfProjectPowerBIObjectDto>(null as any);
    }
}

export class ProjectsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the projects
     * @return The related resources
     */
    getProjects(signal?: AbortSignal | undefined): Promise<ResultOfIListOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/GetProjects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: Response): Promise<ResultOfIListOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfProjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfProjectDto>(null as any);
    }

    /**
     * Gets the project
     * @return The related resources
     */
    getProject(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/GetProject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: Response): Promise<ResultOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectDto>(null as any);
    }

    /**
     * Gets the project related resources
     * @return The related resources
     */
    getProjectRelatedResources(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectRelatedResourcesVm> {
        let url_ = this.baseUrl + "/api/Projects/GetProjectRelatedResources/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectRelatedResources(_response);
        });
    }

    protected processGetProjectRelatedResources(response: Response): Promise<ResultOfProjectRelatedResourcesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectRelatedResourcesVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectRelatedResourcesVm>(null as any);
    }

    /**
     * Gets the project summary
     * @param projectId Project Id
     * @return The related resources
     */
    getProjectSummary(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectSummaryVm> {
        let url_ = this.baseUrl + "/api/Projects/GetProjectSummary/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectSummary(_response);
        });
    }

    protected processGetProjectSummary(response: Response): Promise<ResultOfProjectSummaryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectSummaryVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectSummaryVm>(null as any);
    }

    /**
     * Get all projects in application
     * @return The related resources
     */
    getAllProjectsCount(signal?: AbortSignal | undefined): Promise<ResultOfProjectsCount> {
        let url_ = this.baseUrl + "/api/Projects/GetAllProjectsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllProjectsCount(_response);
        });
    }

    protected processGetAllProjectsCount(response: Response): Promise<ResultOfProjectsCount> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectsCount;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectsCount>(null as any);
    }

    /**
     * Creates a new project
     * @return The new entity
     */
    createProject(command: CreateProjectCommand, signal?: AbortSignal | undefined): Promise<ResultOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: Response): Promise<ResultOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectDto>(null as any);
    }

    /**
     * Updates a project by id
     * @return Ok
     */
    updateProject(command: UpdateProjectCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Projects/UpdateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Updates a project image
     * @param projectId (optional) 
     * @param fileToUpload (optional) 
     * @return Ok
     */
    updateProjectImage(projectId: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/UpdateProjectImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectImage(_response);
        });
    }

    protected processUpdateProjectImage(response: Response): Promise<ResultOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectDto>(null as any);
    }

    /**
     * Updates a project viewer logo
     * @param projectId (optional) 
     * @param fileToUpload (optional) 
     * @return Ok
     */
    updateProjectViewerLogo(projectId: string | null | undefined, fileToUpload: FileParameter | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/UpdateProjectViewerLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (fileToUpload !== null && fileToUpload !== undefined)
            content_.append("FileToUpload", fileToUpload.data, fileToUpload.fileName ? fileToUpload.fileName : "FileToUpload");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProjectViewerLogo(_response);
        });
    }

    protected processUpdateProjectViewerLogo(response: Response): Promise<ResultOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectDto>(null as any);
    }

    /**
     * Removes project by id
     * @return Ok
     */
    removeProject(projectId: string | null, forceDelete: string, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Projects/RemoveProject/{projectId}/{forceDelete}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (forceDelete === undefined || forceDelete === null)
            throw new Error("The parameter 'forceDelete' must be defined.");
        url_ = url_.replace("{forceDelete}", encodeURIComponent("" + forceDelete));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveProject(_response);
        });
    }

    protected processRemoveProject(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Gets the project Forge Objects
     * @return The related resources
     */
    getForgeObjects(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfIListOfForgeObjectDto> {
        let url_ = this.baseUrl + "/api/Projects/GetForgeObjects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForgeObjects(_response);
        });
    }

    protected processGetForgeObjects(response: Response): Promise<ResultOfIListOfForgeObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfForgeObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfForgeObjectDto>(null as any);
    }

    /**
     * Gets the project Forge Object
     * @return The related resource
     */
    getForgeObject(projectId: string | null, id: string | null, signal?: AbortSignal | undefined): Promise<ResultOfForgeObjectDto> {
        let url_ = this.baseUrl + "/api/Projects/GetForgeObject/{projectId}/{id}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetForgeObject(_response);
        });
    }

    protected processGetForgeObject(response: Response): Promise<ResultOfForgeObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfForgeObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfForgeObjectDto>(null as any);
    }

    /**
     * Gets the project user dashboard
     * @return The related resources
     */
    getProjectUserDefaultDashboard(projectId: string | null, signal?: AbortSignal | undefined): Promise<ResultOfProjectPowerBIObjectDto> {
        let url_ = this.baseUrl + "/api/Projects/GetProjectUserDefaultDashboard/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProjectUserDefaultDashboard(_response);
        });
    }

    protected processGetProjectUserDefaultDashboard(response: Response): Promise<ResultOfProjectPowerBIObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfProjectPowerBIObjectDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfProjectPowerBIObjectDto>(null as any);
    }

    /**
     * Set the project user dashboard
     * @return The new entity
     */
    setProjectUserDefaultDashboard(command: SetProjectUserDefaultDashboardCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Projects/SetProjectUserDefaultDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetProjectUserDefaultDashboard(_response);
        });
    }

    protected processSetProjectUserDefaultDashboard(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class QRService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getQR(input: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/QR/GetQR?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQR(_response);
        });
    }

    protected processGetQR(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ReboteService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    dynamic(projectId: string | null | undefined, endpoint: string | null | undefined, input: string | null | undefined, files: FileParameter[] | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfJsonDocument> {
        let url_ = this.baseUrl + "/api/Rebote/Dynamic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (projectId !== null && projectId !== undefined)
            content_.append("ProjectId", projectId.toString());
        if (endpoint !== null && endpoint !== undefined)
            content_.append("Endpoint", endpoint.toString());
        if (input !== null && input !== undefined)
            content_.append("Input", input.toString());
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDynamic(_response);
        });
    }

    protected processDynamic(response: Response): Promise<ResultOfJsonDocument> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 100) {
            return response.text().then((_responseText) => {
            let result100: any = null;
            result100 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result100);
            });
        } else if (status === 101) {
            return response.text().then((_responseText) => {
            let result101: any = null;
            result101 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result101);
            });
        } else if (status === 102) {
            return response.text().then((_responseText) => {
            let result102: any = null;
            result102 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result102);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result200;
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result201;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result202;
            });
        } else if (status === 203) {
            return response.text().then((_responseText) => {
            let result203: any = null;
            result203 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result203;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result204;
            });
        } else if (status === 205) {
            return response.text().then((_responseText) => {
            let result205: any = null;
            result205 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result205;
            });
        } else if (status === 206) {
            return response.text().then((_responseText) => {
            let result206: any = null;
            result206 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result206;
            });
        } else if (status === 207) {
            return response.text().then((_responseText) => {
            let result207: any = null;
            result207 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result207;
            });
        } else if (status === 208) {
            return response.text().then((_responseText) => {
            let result208: any = null;
            result208 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result208;
            });
        } else if (status === 226) {
            return response.text().then((_responseText) => {
            let result226: any = null;
            result226 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return result226;
            });
        } else if (status === 300) {
            return response.text().then((_responseText) => {
            let result300: any = null;
            result300 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result300);
            });
        } else if (status === 301) {
            return response.text().then((_responseText) => {
            let result301: any = null;
            result301 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result301);
            });
        } else if (status === 302) {
            return response.text().then((_responseText) => {
            let result302: any = null;
            result302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result302);
            });
        } else if (status === 303) {
            return response.text().then((_responseText) => {
            let result303: any = null;
            result303 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result303);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            let result304: any = null;
            result304 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result304);
            });
        } else if (status === 305) {
            return response.text().then((_responseText) => {
            let result305: any = null;
            result305 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result305);
            });
        } else if (status === 306) {
            return response.text().then((_responseText) => {
            let result306: any = null;
            result306 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result306);
            });
        } else if (status === 307) {
            return response.text().then((_responseText) => {
            let result307: any = null;
            result307 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result307);
            });
        } else if (status === 308) {
            return response.text().then((_responseText) => {
            let result308: any = null;
            result308 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result308);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 402) {
            return response.text().then((_responseText) => {
            let result402: any = null;
            result402 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result402);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 405) {
            return response.text().then((_responseText) => {
            let result405: any = null;
            result405 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result405);
            });
        } else if (status === 406) {
            return response.text().then((_responseText) => {
            let result406: any = null;
            result406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);
            });
        } else if (status === 407) {
            return response.text().then((_responseText) => {
            let result407: any = null;
            result407 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result407);
            });
        } else if (status === 408) {
            return response.text().then((_responseText) => {
            let result408: any = null;
            result408 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result408);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status === 411) {
            return response.text().then((_responseText) => {
            let result411: any = null;
            result411 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result411);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result412);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            });
        } else if (status === 414) {
            return response.text().then((_responseText) => {
            let result414: any = null;
            result414 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result414);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            let result415: any = null;
            result415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
            });
        } else if (status === 416) {
            return response.text().then((_responseText) => {
            let result416: any = null;
            result416 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result416);
            });
        } else if (status === 417) {
            return response.text().then((_responseText) => {
            let result417: any = null;
            result417 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result417);
            });
        } else if (status === 418) {
            return response.text().then((_responseText) => {
            let result418: any = null;
            result418 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result418);
            });
        } else if (status === 421) {
            return response.text().then((_responseText) => {
            let result421: any = null;
            result421 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result421);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 423) {
            return response.text().then((_responseText) => {
            let result423: any = null;
            result423 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result423);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 426) {
            return response.text().then((_responseText) => {
            let result426: any = null;
            result426 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result426);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            result429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status === 431) {
            return response.text().then((_responseText) => {
            let result431: any = null;
            result431 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result431);
            });
        } else if (status === 451) {
            return response.text().then((_responseText) => {
            let result451: any = null;
            result451 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result451);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            result501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result501);
            });
        } else if (status === 502) {
            return response.text().then((_responseText) => {
            let result502: any = null;
            result502 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result502);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result503);
            });
        } else if (status === 504) {
            return response.text().then((_responseText) => {
            let result504: any = null;
            result504 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result504);
            });
        } else if (status === 505) {
            return response.text().then((_responseText) => {
            let result505: any = null;
            result505 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result505);
            });
        } else if (status === 506) {
            return response.text().then((_responseText) => {
            let result506: any = null;
            result506 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result506);
            });
        } else if (status === 507) {
            return response.text().then((_responseText) => {
            let result507: any = null;
            result507 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result507);
            });
        } else if (status === 508) {
            return response.text().then((_responseText) => {
            let result508: any = null;
            result508 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result508);
            });
        } else if (status === 510) {
            return response.text().then((_responseText) => {
            let result510: any = null;
            result510 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result510);
            });
        } else if (status === 511) {
            return response.text().then((_responseText) => {
            let result511: any = null;
            result511 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfJsonDocument;
            return throwException("A server side error occurred.", status, _responseText, _headers, result511);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfJsonDocument>(null as any);
    }
}

export class RuleSetsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add Power BI Object Rule Sets
     * @return Created
     */
    addPowerBIObjectRuleSets(command: AddRuleSetsVm, signal?: AbortSignal | undefined): Promise<ResultOfIListOfRuleSetDto> {
        let url_ = this.baseUrl + "/api/RuleSets/AddPowerBIObjectRuleSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddPowerBIObjectRuleSets(_response);
        });
    }

    protected processAddPowerBIObjectRuleSets(response: Response): Promise<ResultOfIListOfRuleSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfRuleSetDto>(null as any);
    }

    /**
     * Update Power BI Object Rule Sets
     * @return Ok
     */
    updatePowerBIObjectRuleSets(command: UpdateRuleSetsVm, signal?: AbortSignal | undefined): Promise<ResultOfIListOfRuleSetDto> {
        let url_ = this.baseUrl + "/api/RuleSets/UpdatePowerBIObjectRuleSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePowerBIObjectRuleSets(_response);
        });
    }

    protected processUpdatePowerBIObjectRuleSets(response: Response): Promise<ResultOfIListOfRuleSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfRuleSetDto>(null as any);
    }

    /**
     * Update the Power BI Objects related with the Rule Set
     * @return Ok
     */
    updateRuleSetPowerBIObjects(command: UpdateRuleSetObjectsVm, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/RuleSets/UpdateRuleSetPowerBIObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRuleSetPowerBIObjects(_response);
        });
    }

    protected processUpdateRuleSetPowerBIObjects(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Remove Power BI Object Rule Sets
     * @return Ok
     */
    removePowerBIObjectRuleSets(command: RemoveRuleSetsVm, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/RuleSets/RemovePowerBIObjectRuleSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemovePowerBIObjectRuleSets(_response);
        });
    }

    protected processRemovePowerBIObjectRuleSets(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Power BI Object Rule Sets
     * @return Ok
     */
    getPowerBIObjectRuleSets(query: GetObjectRuleSetsVm, signal?: AbortSignal | undefined): Promise<ResultOfIListOfRuleSetDto> {
        let url_ = this.baseUrl + "/api/RuleSets/GetPowerBIObjectRuleSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPowerBIObjectRuleSets(_response);
        });
    }

    protected processGetPowerBIObjectRuleSets(response: Response): Promise<ResultOfIListOfRuleSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfRuleSetDto>(null as any);
    }

    /**
     * Get Power BI Object Rule Sets
     * @return Ok
     */
    getRuleSetPowerBIObjects(query: GetRuleSetObjectsVm, signal?: AbortSignal | undefined): Promise<ResultOfIListOfRuleSetObjectDetailVm> {
        let url_ = this.baseUrl + "/api/RuleSets/GetRuleSetPowerBIObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRuleSetPowerBIObjects(_response);
        });
    }

    protected processGetRuleSetPowerBIObjects(response: Response): Promise<ResultOfIListOfRuleSetObjectDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetObjectDetailVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfRuleSetObjectDetailVm>(null as any);
    }

    /**
     * Add Collison Set
     * @return Created
     */
    addCollisionSet(command: AddCollisionSetRuleSetCommand, signal?: AbortSignal | undefined): Promise<ResultOfRuleSetDto> {
        let url_ = this.baseUrl + "/api/RuleSets/AddCollisionSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCollisionSet(_response);
        });
    }

    protected processAddCollisionSet(response: Response): Promise<ResultOfRuleSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRuleSetDto>(null as any);
    }

    /**
     * Remove Collision Sets
     * @return Ok
     */
    removeCollisionSets(command: RemoveCollisionSetsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/RuleSets/RemoveCollisionSets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveCollisionSets(_response);
        });
    }

    protected processRemoveCollisionSets(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Rule Sets
     * @param projectId (optional) 
     * @return Ok
     */
    getRuleSets(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfIListOfRuleSetDetailVm> {
        let url_ = this.baseUrl + "/api/RuleSets/GetRuleSets?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRuleSets(_response);
        });
    }

    protected processGetRuleSets(response: Response): Promise<ResultOfIListOfRuleSetDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfIListOfRuleSetDetailVm;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfIListOfRuleSetDetailVm>(null as any);
    }

    /**
     * Get Rule Set
     * @param ruleSetId (optional) 
     * @return Ok
     */
    getRuleSet(ruleSetId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfRuleSetDto> {
        let url_ = this.baseUrl + "/api/RuleSets/GetRuleSet?";
        if (ruleSetId !== undefined && ruleSetId !== null)
            url_ += "ruleSetId=" + encodeURIComponent("" + ruleSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRuleSet(_response);
        });
    }

    protected processGetRuleSet(response: Response): Promise<ResultOfRuleSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRuleSetDto;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRuleSetDto>(null as any);
    }
}

export class SignalsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create user signal group
     * @param projectId (optional) 
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @return The bucket objects
     */
    createUserSignalsGroup(projectId: string | null | undefined, id: string | null | undefined, name: string | null | undefined, description: string | null | undefined, signals: string[], signal?: AbortSignal | undefined): Promise<ResultOfRegisterSignalModel> {
        let url_ = this.baseUrl + "/api/Signals/CreateUserSignalsGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signals);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserSignalsGroup(_response);
        });
    }

    protected processCreateUserSignalsGroup(response: Response): Promise<ResultOfRegisterSignalModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRegisterSignalModel>(null as any);
    }

    /**
     * Delete user signal group
     * @param projectId (optional) 
     * @param id (optional) 
     * @return The bucket objects
     */
    deleteUserSignalsGroup(projectId: string | null | undefined, id: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfRegisterSignalModel> {
        let url_ = this.baseUrl + "/api/Signals/DeleteUserSignalsGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserSignalsGroup(_response);
        });
    }

    protected processDeleteUserSignalsGroup(response: Response): Promise<ResultOfRegisterSignalModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRegisterSignalModel>(null as any);
    }

    /**
     * Update user signal group
     * @param projectId (optional) 
     * @param id (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @return The bucket objects
     */
    updateUserSignalsGroup(projectId: string | null | undefined, id: string | null | undefined, name: string | null | undefined, description: string | null | undefined, signals: string[], signal?: AbortSignal | undefined): Promise<ResultOfRegisterSignalModel> {
        let url_ = this.baseUrl + "/api/Signals/UpdateUserSignalsGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signals);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserSignalsGroup(_response);
        });
    }

    protected processUpdateUserSignalsGroup(response: Response): Promise<ResultOfRegisterSignalModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRegisterSignalModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRegisterSignalModel>(null as any);
    }

    /**
     * Get Signals
     * @return The bucket objects
     */
    getSignals(query: GetSignalsQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetSignalsModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignals(_response);
        });
    }

    protected processGetSignals(response: Response): Promise<ResultOfGetSignalsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetSignalsModel>(null as any);
    }

    /**
     * Get Signal
     * @param projectId (optional) 
     * @param signalId (optional) 
     * @param groupId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sampleSize (optional) 
     * @param relativeTimePrior (optional) 
     * @param relativeTimeInterval (optional) 
     * @return The bucket objects
     */
    getSignal(projectId: string | null | undefined, signalId: string | null | undefined, groupId: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, sampleSize: number | null | undefined, relativeTimePrior: number | null | undefined, relativeTimeInterval: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfGetSignalModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignal?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (signalId !== undefined && signalId !== null)
            url_ += "signalId=" + encodeURIComponent("" + signalId) + "&";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sampleSize !== undefined && sampleSize !== null)
            url_ += "sampleSize=" + encodeURIComponent("" + sampleSize) + "&";
        if (relativeTimePrior !== undefined && relativeTimePrior !== null)
            url_ += "relativeTimePrior=" + encodeURIComponent("" + relativeTimePrior) + "&";
        if (relativeTimeInterval !== undefined && relativeTimeInterval !== null)
            url_ += "relativeTimeInterval=" + encodeURIComponent("" + relativeTimeInterval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignal(_response);
        });
    }

    protected processGetSignal(response: Response): Promise<ResultOfGetSignalModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetSignalModel>(null as any);
    }

    /**
     * Get Signal List
     * @return The bucket objects
     */
    getSignalList(query: GetSignalListQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetSignalListModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalList(_response);
        });
    }

    protected processGetSignalList(response: Response): Promise<ResultOfGetSignalListModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetSignalListModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetSignalListModel>(null as any);
    }

    /**
     * Get Signals Information
     * @return The bucket objects
     */
    getSignalsInformation(query: GetSignalsInformationQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfSignalsInformationModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalsInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalsInformation(_response);
        });
    }

    protected processGetSignalsInformation(response: Response): Promise<ResultOfListOfSignalsInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfSignalsInformationModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfSignalsInformationModel>(null as any);
    }

    /**
     * Add group of signals
     * @param projectId (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @return The bucket objects
     */
    addGroup(projectId: string | null | undefined, name: string | null | undefined, description: string | null | undefined, idSignals: string[], signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/AddGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idSignals);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddGroup(_response);
        });
    }

    protected processAddGroup(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Edit group of signals
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @param name (optional) 
     * @param description (optional) 
     * @return The bucket objects
     */
    editGroup(projectId: string | null | undefined, idGroup: string | null | undefined, name: string | null | undefined, description: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/EditGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditGroup(_response);
        });
    }

    protected processEditGroup(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Remove group of signals
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @return The bucket objects
     */
    removeGroup(projectId: string | null | undefined, idGroup: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/RemoveGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveGroup(_response);
        });
    }

    protected processRemoveGroup(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Group
     * @return The bucket objects
     */
    getGroup(query: GetGroupQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetGroupModel> {
        let url_ = this.baseUrl + "/api/Signals/GetGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroup(_response);
        });
    }

    protected processGetGroup(response: Response): Promise<ResultOfGetGroupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetGroupModel>(null as any);
    }

    /**
     * Get Groups By User
     * @return The bucket objects
     */
    getGroupsByUser(query: GetGroupsByUserQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetGroupsByUserModel> {
        let url_ = this.baseUrl + "/api/Signals/GetGroupsByUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupsByUser(_response);
        });
    }

    protected processGetGroupsByUser(response: Response): Promise<ResultOfGetGroupsByUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetGroupsByUserModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetGroupsByUserModel>(null as any);
    }

    /**
     * Add signal in group of signals
     * @return The bucket objects
     */
    addSignalInGroup(command: AddSignalInGroupCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/AddSignalInGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddSignalInGroup(_response);
        });
    }

    protected processAddSignalInGroup(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Remove signal in group of signals
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @return The bucket objects
     */
    removeSignalInGroup(projectId: string | null | undefined, idGroup: string | null | undefined, idSignals: string[], signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/RemoveSignalInGroup?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idSignals);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveSignalInGroup(_response);
        });
    }

    protected processRemoveSignalInGroup(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Signals Groups By User
     * @param projectId (optional) 
     * @return The bucket objects
     */
    getSignalsGroupsByUser(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfListOfGroupsByUserModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalsGroupsByUser?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalsGroupsByUser(_response);
        });
    }

    protected processGetSignalsGroupsByUser(response: Response): Promise<ResultOfListOfGroupsByUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfGroupsByUserModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfGroupsByUserModel>(null as any);
    }

    /**
     * Change Group Default Dates
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @param defaultStartDate (optional) 
     * @param defaultEndDate (optional) 
     * @param relativeTimePrior (optional) 
     * @param relativeTimeInterval (optional) 
     * @return The bucket objects
     */
    changeGroupDefaultDates(projectId: string | null | undefined, idGroup: string | null | undefined, defaultStartDate: Date | null | undefined, defaultEndDate: Date | null | undefined, relativeTimePrior: number | null | undefined, relativeTimeInterval: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/ChangeGroupDefaultDates?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        if (defaultStartDate !== undefined && defaultStartDate !== null)
            url_ += "defaultStartDate=" + encodeURIComponent(defaultStartDate ? "" + defaultStartDate.toISOString() : "") + "&";
        if (defaultEndDate !== undefined && defaultEndDate !== null)
            url_ += "defaultEndDate=" + encodeURIComponent(defaultEndDate ? "" + defaultEndDate.toISOString() : "") + "&";
        if (relativeTimePrior !== undefined && relativeTimePrior !== null)
            url_ += "relativeTimePrior=" + encodeURIComponent("" + relativeTimePrior) + "&";
        if (relativeTimeInterval !== undefined && relativeTimeInterval !== null)
            url_ += "relativeTimeInterval=" + encodeURIComponent("" + relativeTimeInterval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeGroupDefaultDates(_response);
        });
    }

    protected processChangeGroupDefaultDates(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Change Signal Default Dates
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @param idSignal (optional) 
     * @param defaultStartDate (optional) 
     * @param defaultEndDate (optional) 
     * @return The bucket objects
     */
    changeSignalDefaultDates(projectId: string | null | undefined, idGroup: string | null | undefined, idSignal: string | null | undefined, defaultStartDate: string | null | undefined, defaultEndDate: string | null | undefined, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/ChangeSignalDefaultDates?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        if (idSignal !== undefined && idSignal !== null)
            url_ += "idSignal=" + encodeURIComponent("" + idSignal) + "&";
        if (defaultStartDate !== undefined && defaultStartDate !== null)
            url_ += "defaultStartDate=" + encodeURIComponent("" + defaultStartDate) + "&";
        if (defaultEndDate !== undefined && defaultEndDate !== null)
            url_ += "defaultEndDate=" + encodeURIComponent("" + defaultEndDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeSignalDefaultDates(_response);
        });
    }

    protected processChangeSignalDefaultDates(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Change Signal Dates
     * @param projectId (optional) 
     * @param idGroup (optional) 
     * @param idSignal (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param relativeTimePrior (optional) 
     * @param relativeTimeInterval (optional) 
     * @return The bucket objects
     */
    changeSignalDates(projectId: string | null | undefined, idGroup: string | null | undefined, idSignal: string | null | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined, relativeTimePrior: number | null | undefined, relativeTimeInterval: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfAssetSignalsModel> {
        let url_ = this.baseUrl + "/api/Signals/ChangeSignalDates?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idGroup !== undefined && idGroup !== null)
            url_ += "idGroup=" + encodeURIComponent("" + idGroup) + "&";
        if (idSignal !== undefined && idSignal !== null)
            url_ += "idSignal=" + encodeURIComponent("" + idSignal) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (relativeTimePrior !== undefined && relativeTimePrior !== null)
            url_ += "relativeTimePrior=" + encodeURIComponent("" + relativeTimePrior) + "&";
        if (relativeTimeInterval !== undefined && relativeTimeInterval !== null)
            url_ += "relativeTimeInterval=" + encodeURIComponent("" + relativeTimeInterval) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeSignalDates(_response);
        });
    }

    protected processChangeSignalDates(response: Response): Promise<ResultOfAssetSignalsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfAssetSignalsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfAssetSignalsModel>(null as any);
    }

    /**
     * Get Signals Dashboard By User
     * @param projectId (optional) 
     * @return The bucket objects
     */
    getSignalsDashboardByUser(projectId: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfSignalsGroupsMonitoringModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalsDashboardByUser?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalsDashboardByUser(_response);
        });
    }

    protected processGetSignalsDashboardByUser(response: Response): Promise<ResultOfSignalsGroupsMonitoringModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfSignalsGroupsMonitoringModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfSignalsGroupsMonitoringModel>(null as any);
    }

    /**
     * Get Signals By Dates
     * @param projectId (optional) 
     * @param idSignal (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param lengthOfTime (optional) 
     * @param relativeStart (optional) 
     * @return The bucket objects
     */
    getSignalsByDates(projectId: string | null | undefined, idSignal: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined, lengthOfTime: string | null | undefined, relativeStart: string | null | undefined, signal?: AbortSignal | undefined): Promise<ResultOfListOfAssetSignalsModel> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalsByDates?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (idSignal !== undefined && idSignal !== null)
            url_ += "idSignal=" + encodeURIComponent("" + idSignal) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (lengthOfTime !== undefined && lengthOfTime !== null)
            url_ += "lengthOfTime=" + encodeURIComponent("" + lengthOfTime) + "&";
        if (relativeStart !== undefined && relativeStart !== null)
            url_ += "relativeStart=" + encodeURIComponent("" + relativeStart) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalsByDates(_response);
        });
    }

    protected processGetSignalsByDates(response: Response): Promise<ResultOfListOfAssetSignalsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAssetSignalsModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAssetSignalsModel>(null as any);
    }

    getSignalsTimeloop(subscriptions: SignalsTimeloopModel, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Signals/GetSignalsTimeloop";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subscriptions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignalsTimeloop(_response);
        });
    }

    protected processGetSignalsTimeloop(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Change Subscribe Signals
     * @return The bucket objects
     */
    changeSubscribeSignals(command: ChangeSubscribeSignalsCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Signals/ChangeSubscribeSignals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeSubscribeSignals(_response);
        });
    }

    protected processChangeSubscribeSignals(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class UserAzureService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the Photo Profile
     * @return The bucket objects
     */
    getMyProfilePhotoFromAzure(signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/UserAzure/GetMyProfilePhotoFromAzure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyProfilePhotoFromAzure(_response);
        });
    }

    protected processGetMyProfilePhotoFromAzure(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    /**
     * SendMessageInTeams
     * @return The bucket objects
     */
    sendMessageInTeams(signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/UserAzure/SendMessageInTeams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendMessageInTeams(_response);
        });
    }

    protected processSendMessageInTeams(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get the Photo Profile
     * @return The bucket objects
     */
    encryptString(query: EncryptStringQuery, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/UserAzure/EncryptString";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEncryptString(_response);
        });
    }

    protected processEncryptString(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    createAzureUsers(command: CreateAzureUsers, signal?: AbortSignal | undefined): Promise<ResultOfListOfString> {
        let url_ = this.baseUrl + "/api/UserAzure/CreateAzureUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAzureUsers(_response);
        });
    }

    protected processCreateAzureUsers(response: Response): Promise<ResultOfListOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfString>(null as any);
    }

    resetUsersPassword(command: ResetUsersPassword, signal?: AbortSignal | undefined): Promise<ResultOfListOfResetUsersPasswordModel> {
        let url_ = this.baseUrl + "/api/UserAzure/ResetUsersPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetUsersPassword(_response);
        });
    }

    protected processResetUsersPassword(response: Response): Promise<ResultOfListOfResetUsersPasswordModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfResetUsersPasswordModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfResetUsersPasswordModel>(null as any);
    }

    changeNamePasswordUser(command: ChangeNamePasswordUser, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/UserAzure/ChangeNamePasswordUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeNamePasswordUser(_response);
        });
    }

    protected processChangeNamePasswordUser(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getUserRole(signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/UserAzure/GetUserRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserRole(_response);
        });
    }

    protected processGetUserRole(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    getAvailableRoles(query: GetAvailableRoles, signal?: AbortSignal | undefined): Promise<ResultOfListOfAppRoleAssignment> {
        let url_ = this.baseUrl + "/api/UserAzure/GetAvailableRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableRoles(_response);
        });
    }

    protected processGetAvailableRoles(response: Response): Promise<ResultOfListOfAppRoleAssignment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAppRoleAssignment;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAppRoleAssignment>(null as any);
    }

    getValidDomain(query: GetValidDomain, signal?: AbortSignal | undefined): Promise<ResultOfString> {
        let url_ = this.baseUrl + "/api/UserAzure/GetValidDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetValidDomain(_response);
        });
    }

    protected processGetValidDomain(response: Response): Promise<ResultOfString> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfString;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfString>(null as any);
    }

    getUsersFromAzureTenant(query: GetUsersFromAzureTenantQuery, signal?: AbortSignal | undefined): Promise<ResultOfListOfAzureUsersModel> {
        let url_ = this.baseUrl + "/api/UserAzure/GetUsersFromAzureTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersFromAzureTenant(_response);
        });
    }

    protected processGetUsersFromAzureTenant(response: Response): Promise<ResultOfListOfAzureUsersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfListOfAzureUsersModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfListOfAzureUsersModel>(null as any);
    }

    modifyUsersInGroups(command: ModifyUsersInGroups, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/UserAzure/ModifyUsersInGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processModifyUsersInGroups(_response);
        });
    }

    protected processModifyUsersInGroups(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class UserInformationService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * SetUserInformation
     * @return The bucket objects
     */
    setUserInformation(query: SetUserInformationCommand, signal?: AbortSignal | undefined): Promise<ResultOfUserInformation> {
        let url_ = this.baseUrl + "/api/UserInformation/SetUserInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserInformation(_response);
        });
    }

    protected processSetUserInformation(response: Response): Promise<ResultOfUserInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserInformation;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfUserInformation>(null as any);
    }

    /**
     * SetAllUsersInformation
     * @return The bucket objects
     */
    setAllUsersInformation(query: SetAllUsersInformationCommand, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/UserInformation/SetAllUsersInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAllUsersInformation(_response);
        });
    }

    protected processSetAllUsersInformation(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    /**
     * Get Users With Permits
     * @return The bucket objects
     */
    getUsersWithPermits(query: GetUsersWithPermitsQuery, signal?: AbortSignal | undefined): Promise<ResultOfUsersWithPermits> {
        let url_ = this.baseUrl + "/api/UserInformation/GetUsersWithPermits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersWithPermits(_response);
        });
    }

    protected processGetUsersWithPermits(response: Response): Promise<ResultOfUsersWithPermits> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersWithPermits;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfUsersWithPermits>(null as any);
    }

    /**
     * Get User With Permits
     * @return The bucket objects
     */
    getUserWithPermits(query: GetUserWithPermitsQuery, signal?: AbortSignal | undefined): Promise<ResultOfUserWithPermits> {
        let url_ = this.baseUrl + "/api/UserInformation/GetUserWithPermits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserWithPermits(_response);
        });
    }

    protected processGetUserWithPermits(response: Response): Promise<ResultOfUserWithPermits> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUserWithPermits;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfUserWithPermits>(null as any);
    }

    /**
     * Get Users By Role
     * @return The bucket objects
     */
    getUsersByRole(query: GetUsersByRoleQuery, signal?: AbortSignal | undefined): Promise<ResultOfUsersByRole> {
        let url_ = this.baseUrl + "/api/UserInformation/GetUsersByRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByRole(_response);
        });
    }

    protected processGetUsersByRole(response: Response): Promise<ResultOfUsersByRole> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersByRole;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfUsersByRole>(null as any);
    }

    /**
     * Get Roles
     * @return The bucket objects
     */
    getRoles(query: GetRolesQuery, signal?: AbortSignal | undefined): Promise<ResultOfRolesModel> {
        let url_ = this.baseUrl + "/api/UserInformation/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<ResultOfRolesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfRolesModel;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfRolesModel>(null as any);
    }

    /**
     * Get Default Role
     * @return The bucket objects
     */
    getDefaultRole(query: GetDefaultRoleQuery, signal?: AbortSignal | undefined): Promise<ResultOfGetDefaultRoleOutput> {
        let url_ = this.baseUrl + "/api/UserInformation/GetDefaultRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultRole(_response);
        });
    }

    protected processGetDefaultRole(response: Response): Promise<ResultOfGetDefaultRoleOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return throwException("Invalid request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return throwException("Not authenticated", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return throwException("Not authorized", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return throwException("Not found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfGetDefaultRoleOutput;
            return throwException("Internal error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfGetDefaultRoleOutput>(null as any);
    }
}

export class UserPermitsService extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getUsersPermits(query: GetUsersPermitsQuery, signal?: AbortSignal | undefined): Promise<ResultOfUsersPermitsModel> {
        let url_ = this.baseUrl + "/api/UserPermits/GetUsersPermits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersPermits(_response);
        });
    }

    protected processGetUsersPermits(response: Response): Promise<ResultOfUsersPermitsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfUsersPermitsModel;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfUsersPermitsModel>(null as any);
    }

    updateUsersPermits(query: UpdateUsersPermitsQuery, signal?: AbortSignal | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/UserPermits/UpdateUsersPermits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUsersPermits(_response);
        });
    }

    protected processUpdateUsersPermits(response: Response): Promise<Result> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Result>(null as any);
    }

    getUserPermits(query: GetUserPermitsQuery, signal?: AbortSignal | undefined): Promise<ResultOfDictionaryOfStringAndShort> {
        let url_ = this.baseUrl + "/api/UserPermits/GetUserPermits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserPermits(_response);
        });
    }

    protected processGetUserPermits(response: Response): Promise<ResultOfDictionaryOfStringAndShort> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultOfDictionaryOfStringAndShort;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultOfDictionaryOfStringAndShort>(null as any);
    }
}

export interface Result {
    resultType: ResultType;
    errorDescription?: ErrorDescription | undefined;
    status: string;
    statusCode: number;
}

export interface ResultOfListOfAzureUsersModel extends Result {
    data: AzureUsersModel[];
}

export interface AzureUsersModel {
    id?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    displayName?: string | undefined;
    mail?: string | undefined;
    photo?: string | undefined;
    groupId?: string | undefined;
}

export enum ResultType {
    Succeeded = 1,
    Incoherence = 2,
    Failed = 3,
    Error = 4,
}

export interface ErrorDescription {
    id: string;
    type: ErrorResultType;
    message: string;
    details?: any | undefined;
}

export enum ErrorResultType {
    Unknown = 1,
    Unauthorized = 2,
    Validation = 3,
    NotFound = 4,
    Network = 5,
    Database = 6,
    Conflict = 7,
    ForgeApi = 8,
    ExternalAPI = 9,
}

export interface GetUsersFromAzureQuery {
    projectId: string;
}

export interface ResultOfPanelsResponseModel extends Result {
    data: PanelsResponseModel;
}

export interface PanelsResponseModel {
    panels?: PanelModel[] | undefined;
}

export interface PanelModel {
    id?: string | undefined;
    order?: number;
    location?: string | undefined;
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    subpanels?: Subpanel[] | undefined;
}

export interface Subpanel {
    id?: string | undefined;
    order?: number;
    title?: string | undefined;
    description?: string | undefined;
    filters?: GenericFilterModel[] | undefined;
    items?: PanelItemModel[] | undefined;
}

export interface GenericFilterModel {
    id?: string | undefined;
    level?: string | undefined;
    order?: number;
    type?: string | undefined;
    field?: string | undefined;
    label?: string | undefined;
    placeHolder?: string | undefined;
    multiselect?: boolean;
    includeTime?: boolean;
    options?: GenericFilterOptions[] | undefined;
    defaultValues?: string[] | undefined;
    enabled?: boolean;
    propaga?: boolean;
    defaultFilter?: boolean;
}

export interface GenericFilterOptions {
    text?: string | undefined;
    value?: string | undefined;
    isDefault?: number | undefined;
}

export interface PanelItemModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    onModel?: boolean;
}

export interface ResultOfPanelItemsModel extends Result {
    data: PanelItemsModel;
}

export interface PanelItemsModel {
    items?: PanelItemModel[] | undefined;
}

export interface GetProjectInfoAPIQueryOfPanelItemsModel {
    projectId: string;
}

export interface FilterPanelsInfoCommand extends GetProjectInfoAPIQueryOfPanelItemsModel {
    filters?: FilterFieldValueModel[] | undefined;
}

export interface FilterFieldValueModel {
    id?: string | undefined;
    operator?: string | undefined;
    value?: string[] | undefined;
}

export interface ResetFilterPanelsInfoCommand extends GetProjectInfoAPIQueryOfPanelItemsModel {
    panelId?: number;
}

export interface ResultOfListOfPanelItemsModel extends Result {
    data: PanelItemsModel[];
}

export interface GetProjectInfoAPIQueryOfListOfPanelItemsModel {
    projectId: string;
}

export interface ResetAllFilterPanelsInfoCommand extends GetProjectInfoAPIQueryOfListOfPanelItemsModel {
    panelsIds?: number[] | undefined;
}

export interface ResultOfAppConfigurationViewModel extends Result {
    data: AppConfigurationViewModel;
}

export interface AppConfigurationViewModel {
    mailServiceConfiguration: MailServiceConfigurationViewModel;
    applicationHost: string;
    documentManagerConfiguration: DocumentManagerConfigurationViewModel;
}

export interface MailServiceConfigurationViewModel {
    mail: string;
    displayName: string;
    host: string;
    port: number;
}

export interface DocumentManagerConfigurationViewModel {
    baseAddress: string;
    user: string;
}

export interface UpdateAppConfigurationCommand {
    appConfiguation: AppConfigurationModel;
}

export interface AppConfigurationModel {
    mailServiceConfiguration?: MailServiceConfigurationModel | undefined;
    applicationHost?: string | undefined;
    documentManagerConfiguration?: DocumentManagerConfigurationModel | undefined;
}

export interface MailServiceConfigurationModel {
    mail?: string | undefined;
    displayName?: string | undefined;
    password?: string | undefined;
    host?: string | undefined;
    port?: number;
}

export interface DocumentManagerConfigurationModel {
    baseAddress?: string | undefined;
    user?: string | undefined;
    password?: string | undefined;
}

export interface ResultOfIdentityConfiguration extends Result {
    data: IdentityConfiguration;
}

export interface IdentityConfiguration {
    response_type: string;
    scope: string;
    loadUserInfo: boolean;
    base_redirect_uri: string;
    filterProtocolClaims: boolean;
    automaticSilentRenew: boolean;
    includeIdTokenInSilentRenew: boolean;
    authority: string;
    client_id: string;
    validateSubOnSilentRenew: boolean;
}

export interface ResultOfString extends Result {
    data: string;
}

export interface GetAppUrlQuery {
}

export interface AddAssetControlViewCommand {
    projectId: string;
    view?: FullAssetControlViewModel | undefined;
}

export interface FullAssetControlViewModel {
    viewId?: string | undefined;
    viewName?: string | undefined;
    viewDescription?: string | undefined;
    tagColumn?: string | undefined;
    default?: ResultRuleModel | undefined;
    rules?: RuleModel[] | undefined;
    source?: SourceModel | undefined;
}

export interface ResultRuleModel {
    color?: string | undefined;
    tooltip?: string | undefined;
}

export interface RuleModel {
    ruleId?: string | undefined;
    condition?: string | undefined;
    controlColumn?: string | undefined;
    rulePriority?: number;
    ruleType?: string | undefined;
    includesBottomEnd?: boolean;
    includesTopEnd?: boolean;
    ruleValue?: string | undefined;
    result?: ResultRuleModel | undefined;
}

export interface SourceModel {
    name?: string | undefined;
    sheet?: string | undefined;
    platform?: string | undefined;
}

export interface ResultOfFullAssetControlViewModel extends Result {
    data: FullAssetControlViewModel;
}

export interface EditAssetControlViewCommand {
    projectId: string;
    view?: FullAssetControlViewModel | undefined;
}

export interface CreateProjectInfoAPICommand {
    projectId: string;
}

export interface DeleteAssetControlViewCommand extends CreateProjectInfoAPICommand {
    viewId?: string | undefined;
}

export interface ResultOfViewsModel extends Result {
    data: ViewsModel;
}

export interface ViewsModel {
    views?: FullAssetControlViewModel[] | undefined;
}

export interface ResultOfRenderViewsModel extends Result {
    data: RenderViewsModel;
}

export interface RenderViewsModel {
    views?: RenderAssetControlViewModel[] | undefined;
}

export interface RenderAssetControlViewModel {
    viewId?: string | undefined;
    viewName?: string | undefined;
    viewDescription?: string | undefined;
    icon?: string | undefined;
}

export interface ResultOfRenderViewModel extends Result {
    data: RenderViewModel;
}

export interface RenderViewModel {
    render?: RenderModel[] | undefined;
    legend?: LegendModel[] | undefined;
}

export interface RenderModel {
    dbIds?: number[] | undefined;
    tooltip?: TooltipModel | undefined;
    style?: StyleModel | undefined;
}

export interface TooltipModel {
    type?: string | undefined;
    content?: string | undefined;
}

export interface StyleModel {
    hexColor?: string | undefined;
}

export interface LegendModel {
    ruleName?: string | undefined;
    ruleColor?: string | undefined;
}

export interface ResultOfExcelInfoModel extends Result {
    data: ExcelInfoModel;
}

export interface ExcelInfoModel {
    fileName?: string | undefined;
    sheets?: SheetExcelModel[] | undefined;
}

export interface SheetExcelModel {
    sheetName?: string | undefined;
    columns?: ExcelColumnModel[] | undefined;
}

export interface ExcelColumnModel {
    columnName?: string | undefined;
    columnType?: string | undefined;
    previewValues?: PreviewExcelValuesModel[] | undefined;
}

export interface PreviewExcelValuesModel {
    row?: number;
    value?: string | undefined;
}

export interface ResultOfAssetControlModel extends Result {
    data: AssetControlModel;
}

export interface AssetControlModel {
    render?: RenderModel2[] | undefined;
    legend?: AssetControlLegendModel[] | undefined;
}

export interface RenderModel2 {
    dbIds?: number[] | undefined;
    tooltip?: TooltipModel2 | undefined;
    style?: StyleModel2 | undefined;
}

export interface TooltipModel2 {
    type?: string | undefined;
    content?: string | undefined;
}

export interface StyleModel2 {
    hexColor?: string | undefined;
}

export interface AssetControlLegendModel {
    ruleName?: string | undefined;
    ruleColor?: string | undefined;
}

export interface ResultOfAssetControlRulesModel extends Result {
    data: AssetControlRulesModel;
}

export interface AssetControlRulesModel {
    controlRules?: AssetControlRuleModel[] | undefined;
}

export interface AssetControlRuleModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    originPlatform?: string | undefined;
    originName?: string | undefined;
    tag?: string | undefined;
    value?: string | undefined;
    type?: string | undefined;
}

export interface ResultOfListOfString extends Result {
    data: string[];
}

export interface DownloadFileToAssetControlCommand {
    projectId?: string | undefined;
    name?: string | undefined;
}

export interface ResultOfExcelPagesModel extends Result {
    data: ExcelPagesModel;
}

export interface ExcelPagesModel {
    pages?: string[] | undefined;
}

export interface ResultOfExcelColumnsModel extends Result {
    data: ExcelColumnsModel;
}

export interface ExcelColumnsModel {
    columns?: OldExcelColumnModel[] | undefined;
}

export interface OldExcelColumnModel {
    name?: string | undefined;
    type?: string | undefined;
}

export interface CreateAssetControlCommand extends CreateProjectInfoAPICommand {
    name?: string | undefined;
    description?: string | undefined;
    tag?: string | undefined;
    origin?: AssetControlOriginModel | undefined;
    rules?: AddAssetControlRulesModel | undefined;
}

export interface AssetControlOriginModel {
    name?: string | undefined;
    page?: string | undefined;
    platform?: string | undefined;
}

export interface AddAssetControlRulesModel {
    rules?: AddAssetControlRuleModel[] | undefined;
    default?: AddAssetControlDefaultRuleModel | undefined;
}

export interface AddAssetControlRuleModel {
    control?: string | undefined;
    type?: string | undefined;
    condition?: string | undefined;
    value?: string | undefined;
    priority?: number;
    result?: AddAssetControlRuleResultModel | undefined;
}

export interface AddAssetControlRuleResultModel {
    color?: string | undefined;
    tooltip?: string | undefined;
}

export interface AddAssetControlDefaultRuleModel {
    result?: AddAssetControlRuleResultModel | undefined;
}

export interface EditAssetControlCommand extends CreateProjectInfoAPICommand {
    name?: string | undefined;
    description?: string | undefined;
}

export interface EditAssetControlRulesCommand extends CreateProjectInfoAPICommand {
    idVista?: string | undefined;
    rules?: AddAssetControlRulesModel | undefined;
}

export interface DeleteAssetControlCommand extends CreateProjectInfoAPICommand {
    idVista?: string | undefined;
}

export interface ResultOfTXTRulesModel extends Result {
    data: TXTRulesModel;
}

export interface TXTRulesModel {
    txtRules?: TXTRuleModel[] | undefined;
}

export interface TXTRuleModel {
    idVista?: string | undefined;
    condition?: string | undefined;
    value?: string | undefined;
    color?: string | undefined;
    priority?: string | undefined;
    tooltip?: string | undefined;
    type?: string | undefined;
}

export interface CreateAssetCommand {
    projectId: string;
    dbIds: number[];
    tag: string;
    description: string;
    assetType?: string | undefined;
    parentId?: string | undefined;
    properties?: CreateAssetPropertiesModel[] | undefined;
    assetProperties?: CreateAssetPropertiesModel[] | undefined;
}

export interface CreateAssetPropertiesModel {
    key?: string | undefined;
    value?: string | undefined;
    order?: number | undefined;
}

export interface DeleteAssetCommand {
    projectId: string;
    id: string;
}

export interface UpdateAssetCommand {
    projectId: string;
    id?: string | undefined;
    dbIds?: number[] | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    parentId?: string | undefined;
    properties?: CreateAssetPropertiesModel[] | undefined;
    assetProperties?: CreateAssetPropertiesModel[] | undefined;
}

export interface ResultOfGetAssetModel extends Result {
    data: GetAssetModel;
}

export interface GetAssetModel {
    dbIds?: number[] | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    parentId?: string | undefined;
    properties?: CreateAssetPropertiesModel[] | undefined;
    assetProperties?: CreateAssetPropertiesModel[] | undefined;
}

export interface GetAssetQuery {
    projectId: string;
    id: string;
}

export interface ResultOfFindTheFatherModel extends Result {
    data: FindTheFatherModel;
}

export interface FindTheFatherModel {
    panels?: PanelModel[] | undefined;
    assetProperties?: FindTheFatherAssetPropertiesModel[] | undefined;
}

export interface FindTheFatherAssetPropertiesModel {
    key?: string | undefined;
    propertyType?: string | undefined;
    values?: string[] | undefined;
}

export interface FindTheFatherQuery {
    projectId: string;
    assetType: string;
}

export interface ResultOfListAllTagsModel extends Result {
    data: ListAllTagsModel;
}

export interface ListAllTagsModel {
    tags?: string[] | undefined;
}

export interface ListAllTagsQuery {
    projectId: string;
}

export interface ResultOfListOfIndexModel extends Result {
    data: IndexModel[];
}

export interface IndexModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    dbIds?: number[] | undefined;
}

export interface GetProjectInfoAPIQueryOfListOfIndexModel {
    projectId: string;
}

export interface GetAllAssetsQuery extends GetProjectInfoAPIQueryOfListOfIndexModel {
}

export interface ResultOfFullAssetInformationModel extends Result {
    data: FullAssetInformationModel;
}

export interface FullAssetInformationModel {
    rightPanels?: RightPanelsModel | undefined;
    index?: IndexModel | undefined;
    render?: RenderModel2[] | undefined;
}

export interface RightPanelsModel {
    info?: InfoModel | undefined;
    signals?: SignalsModel | undefined;
    documents?: DocumentsModel | undefined;
    chat?: CommentsModel | undefined;
    context?: ContextModel | undefined;
    alarms?: AlarmsModel | undefined;
}

export interface InfoModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: { [key: string]: InfoDataModel[]; } | undefined;
}

export interface InfoDataModel {
    key?: string | undefined;
    value?: string | undefined;
    order?: number | undefined;
}

export interface SignalsModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: SignalsInfoMeasurementsModel[] | undefined;
}

export interface SignalsInfoMeasurementsModel {
    info?: SignalsInfoModel | undefined;
    measurements?: SignalsMeasurementsModel[] | undefined;
}

export interface SignalsInfoModel {
    icon?: AssetSignalsIconModel | undefined;
    dbIds?: number[] | undefined;
}

export interface AssetSignalsIconModel {
    type?: string | undefined;
    color?: string | undefined;
}

export interface SignalsMeasurementsModel {
    avg?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    timestamp?: Date | undefined;
}

export interface DocumentsModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: DocumentModel[] | undefined;
    filters?: GenericFilterModel[] | undefined;
    foldersDocuments?: FolderDocumentsModel[] | undefined;
}

export interface DocumentModel {
    projectId?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    userId?: string | undefined;
    tags?: string[] | undefined;
    createdAt?: Date;
    mimeType?: string | undefined;
}

export interface FolderDocumentsModel {
    folder?: string | undefined;
    documents?: DocumentModel[] | undefined;
}

export interface CommentsModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: ChatMessageObject[] | undefined;
}

export interface ChatMessageObject {
    idMsg?: string | undefined;
    idAsset?: string | undefined;
    idUser?: string | undefined;
    nombreUser?: string | undefined;
    comment?: string | undefined;
    datetime?: string | undefined;
    userImageUrl?: string | undefined;
    status?: string | undefined;
    file?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    fileSize?: string | undefined;
}

export interface ContextModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: RecursiveContextListNameModel[] | undefined;
}

export interface RecursiveContextListNameModel {
    name?: string | undefined;
    children?: RecursiveContextListChildrenModel[] | undefined;
}

export interface RecursiveContextListChildrenModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    onModel?: boolean;
    parent?: string | undefined;
    data?: RecursiveContextListNameModel[] | undefined;
}

export interface AlarmsModel {
    icon?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    data?: AlarmModel[] | undefined;
}

export interface AlarmModel {
    signalId?: string | undefined;
    signalTag?: string | undefined;
    parent?: AlarmParentModel | undefined;
}

export interface AlarmParentModel {
    id?: string | undefined;
    ruleId?: string | undefined;
    value?: string | undefined;
    operator?: string | undefined;
    label?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
}

export interface GetProjectInfoAPIQueryOfIReadOnlyCollectionOfIndexModel {
    projectId: string;
}

export interface GetAssetsDbIdsQuery extends GetProjectInfoAPIQueryOfIReadOnlyCollectionOfIndexModel {
    tags?: string[] | undefined;
}

export interface ResultOfIReadOnlyCollectionOfCategoryModel extends Result {
    data: CategoryModel[];
}

export interface CategoryModel {
    category?: string | undefined;
    properties?: PropertyModel[] | undefined;
}

export interface PropertyModel {
    propertyCode?: string | undefined;
    displayName?: string | undefined;
}

export interface ResultOfAPIResponseModel extends Result {
    data: APIResponseModel;
}

export interface APIResponseModel {
    displayMode?: string | undefined;
    assets?: AssetInformationModel[] | undefined;
    permitsToWork?: PermitsToWorkModel | undefined;
}

export interface AssetInformationModel {
    dbIds?: number[] | undefined;
    toolTip?: AssetTooltipModel | undefined;
    style?: AssetStyleModel | undefined;
    data?: { [key: string]: any; } | undefined;
    window?: { [key: string]: any; } | undefined;
}

export interface AssetTooltipModel {
    type?: string | undefined;
    content?: string | undefined;
}

export interface AssetStyleModel {
    highlightColor?: number[] | undefined;
    hexColor?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
}

export interface PermitsToWorkModel {
    permitsToWork?: PermitToWorkModel[] | undefined;
    permitsToWorkFilters?: PermitToWorkFiltersModel[] | undefined;
}

export interface PermitToWorkModel {
    id?: string | undefined;
    tag?: string | undefined;
    warning?: string | undefined;
    workType?: string | undefined;
    info?: { [key: string]: any; } | undefined;
    geometry?: PermitToWorkGeometryModel | undefined;
}

export interface PermitToWorkGeometryModel {
    unit?: string | undefined;
    centerDbIds?: number[] | undefined;
    shape?: string | undefined;
    height?: number | undefined;
    radius?: number | undefined;
    color?: string | undefined;
}

export interface PermitToWorkFiltersModel {
    id?: string | undefined;
    level?: string | undefined;
    order?: number;
    type?: string | undefined;
    field?: string | undefined;
    label?: string | undefined;
    placeHolder?: string | undefined;
    multiselect?: boolean;
    includeTime?: boolean;
    options?: PermitToWorkGenericFilterOptions[] | undefined;
    defaultValues?: string[] | undefined;
    enabled?: boolean;
    propaga?: boolean;
    defaultFilter?: boolean;
}

export interface PermitToWorkGenericFilterOptions {
    text?: string | undefined;
    value?: string | undefined;
}

export interface GetProjectInfoAPIQueryOfAPIResponseModel {
    projectId: string;
}

export interface GetPermitsToWorkQuery extends GetProjectInfoAPIQueryOfAPIResponseModel {
    date?: Date | undefined;
}

export interface ResultOfIReadOnlyCollectionOfCollisionResponseModel extends Result {
    data: CollisionResponseModel[];
}

export interface CollisionResponseModel {
    permitId1?: string | undefined;
    permitId2?: string | undefined;
    risk?: string | undefined;
    riskColor?: string | undefined;
    distance?: string | undefined;
}

export interface GetProjectInfoAPIQueryOfIReadOnlyCollectionOfCollisionResponseModel {
    projectId: string;
}

export interface CalculateCollisionsCommand extends GetProjectInfoAPIQueryOfIReadOnlyCollectionOfCollisionResponseModel {
    input?: CollisionRequestModel[] | undefined;
}

export interface CollisionRequestModel {
    permitId?: string | undefined;
    shape?: string | undefined;
    center?: Point3DModel | undefined;
    radius?: number;
    height?: number;
    permitType?: string | undefined;
    boundingBox?: SizeModel | undefined;
}

export interface Point3DModel {
    x?: number;
    y?: number;
    z?: number;
}

export interface SizeModel {
    sizeX?: number;
    sizeY?: number;
    sizeZ?: number;
}

export interface ResultOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel extends Result {
    data: CollisionWithEquipmentResponseModel[];
}

export interface CollisionWithEquipmentResponseModel {
    mainPermit?: string | undefined;
    colidingPermits?: CollisionColidingPermitModel[] | undefined;
}

export interface CollisionColidingPermitModel {
    permitId?: string | undefined;
    risk?: string | undefined;
    riskColor?: string | undefined;
    distance?: string | undefined;
}

export interface GetProjectInfoAPIQueryOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel {
    projectId: string;
}

export interface CalculateCollisionsWithEquipmentCommand extends GetProjectInfoAPIQueryOfIReadOnlyCollectionOfCollisionWithEquipmentResponseModel {
    input?: CollisionRequestModel[] | undefined;
}

export interface ResultOfAssetsPowerBIReportsModel extends Result {
    data: AssetsPowerBIReportsModel;
}

export interface AssetsPowerBIReportsModel {
    assets?: AssetPowerBIReportModel[] | undefined;
}

export interface AddAssetPowerBIReportModel {
    id?: string | undefined;
    powerBIAccountId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    tag?: string | undefined;
    bookMark?: string | undefined;
    createdBy?: string | undefined;
}

export interface AssetPowerBIReportModel extends AddAssetPowerBIReportModel {
    dbIds?: number[] | undefined;
}

export interface AddAssetsPowerBIReportsCommand extends CreateProjectInfoAPICommand {
    assets?: AddAssetPowerBIReportModel[] | undefined;
}

export interface DeleteAssetsPowerBIReportsCommand extends CreateProjectInfoAPICommand {
    powerBIAccountsId?: string[] | undefined;
}

export interface ResultOfListOfAssetInformationModel extends Result {
    data: AssetInformationModel[];
}

export interface ResultOfAssetsWithDocuments extends Result {
    data: AssetsWithDocuments;
}

export interface AssetsWithDocuments {
    assets?: ComponentsOfAssetsWithDocuments[] | undefined;
}

export interface ComponentsOfAssetsWithDocuments {
    tag?: string | undefined;
    description?: string | undefined;
    id?: string | undefined;
    documentos?: DocumentAssetsModel[] | undefined;
    foldersDocuments?: FolderDocumentsAssetsModel[] | undefined;
}

export interface DocumentAssetsModel {
    id?: string | undefined;
    title?: string | undefined;
    code?: string | undefined;
    rev?: string | undefined;
    name?: string | undefined;
    configId?: string | undefined;
    tag?: string[] | undefined;
    createdBy?: string | undefined;
    created?: string | undefined;
    type?: string | undefined;
    typology?: string | undefined;
    projectId?: string | undefined;
    extension?: string | undefined;
    sheet?: string | undefined;
}

export interface FolderDocumentsAssetsModel {
    folder?: string | undefined;
    documents?: DocumentAssetsModel[] | undefined;
}

export interface ResultOfGetAssetsForDbidModel extends Result {
    data: GetAssetsForDbidModel;
}

export interface GetAssetsForDbidModel {
    assets?: GetAssetsForDbidContentModel[] | undefined;
}

export interface GetAssetsForDbidContentModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    dbIds?: number[] | undefined;
    icon?: string | undefined;
    info?: string | undefined;
    children?: GetAssetsForDbidChildrenModel[] | undefined;
}

export interface GetAssetsForDbidChildrenModel {
    id?: string | undefined;
    tag?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    info?: string | undefined;
    children?: GetAssetsForDbidChildrenModel[] | undefined;
}

export interface GetProjectInfoAPIQueryOfFullAssetInformationModel {
    projectId: string;
}

export interface GetAllCategoriesQuery extends GetProjectInfoAPIQueryOfFullAssetInformationModel {
}

export interface CreateThreadCommand {
    projectId?: string | undefined;
    input?: CreateThreadInputModel | undefined;
}

export interface CreateThreadInputModel {
    title?: string | undefined;
    assetId?: string | undefined;
    userId?: string | undefined;
    isPublic?: boolean;
    sharedWith?: string[] | undefined;
}

export interface DeleteThreadCommand {
    projectId?: string | undefined;
    input?: DeleteThreadInputModel | undefined;
}

export interface DeleteThreadInputModel {
    threadId?: string | undefined;
    userId?: string | undefined;
}

export interface ResultOfGetThreadsOutputModel extends Result {
    data: GetThreadsOutputModel;
}

export interface GetThreadsOutputModel {
    threads?: GetThreadsOutputThreadsModel[] | undefined;
}

export interface GetThreadsOutputThreadsModel {
    threadId?: string | undefined;
    title?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    isPublic?: boolean;
    deletedAt?: Date | undefined;
    deletedBy?: string | undefined;
    sharedWith?: GetThreadsOutputSharedWithModel[] | undefined;
    messages?: GetThreadsOutputMessagesModel[] | undefined;
}

export interface GetThreadsOutputSharedWithModel {
    userId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
}

export interface GetThreadsOutputMessagesModel {
    messageId?: string | undefined;
    isFile?: boolean;
    message?: string | undefined;
    fileName?: string | undefined;
    fileType?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    readBy?: GetThreadsOutputReadByModel[] | undefined;
}

export interface GetThreadsOutputReadByModel {
    userId?: string | undefined;
    date?: Date;
}

export interface GetThreadsQuery {
    projectId?: string | undefined;
    input?: GetThreadsInputModel | undefined;
}

export interface GetThreadsInputModel {
    assetId?: string | undefined;
}

export interface EditMessageCommand {
    projectId?: string | undefined;
    input?: EditMessageInputModel | undefined;
}

export interface EditMessageInputModel {
    messageId?: string | undefined;
    message?: string | undefined;
}

export interface DeleteMessageCommand {
    projectId?: string | undefined;
    input?: DeleteMessageInputModel | undefined;
}

export interface DeleteMessageInputModel {
    messageId?: string | undefined;
}

export interface ResultOfGetMessagesOutputModel extends Result {
    data: GetMessagesOutputModel;
}

export interface GetMessagesOutputModel {
    messages?: GetThreadsOutputMessagesModel[] | undefined;
}

export interface GetMessagesQuery {
    projectId?: string | undefined;
    input?: GetMessagesInputModel | undefined;
}

export interface GetMessagesInputModel {
    projectId?: string | undefined;
    threadId?: string | undefined;
}

export interface InsertReadMessagesCommand {
    projectId?: string | undefined;
    input?: InsertReadMessagesInputModel | undefined;
}

export interface InsertReadMessagesInputModel {
    userId?: string | undefined;
    messages?: string[] | undefined;
}

export interface ResultOfGetReadMessagesOutputModel extends Result {
    data: GetReadMessagesOutputModel;
}

export interface GetReadMessagesOutputModel {
    readBy?: GetThreadsOutputReadByModel[] | undefined;
}

export interface GetReadMessagesQuery {
    projectId?: string | undefined;
    input?: GetReadMessagesInputModel | undefined;
}

export interface GetReadMessagesInputModel {
    projectId?: string | undefined;
    messageId?: string | undefined;
}

export interface AddThreadSubscriptionCommand {
    projectId?: string | undefined;
    input?: AddThreadSubscriptionInputModel | undefined;
}

export interface AddThreadSubscriptionInputModel {
    threadId?: string | undefined;
    userId?: string | undefined;
}

export interface DeleteThreadSubscriptionCommand {
    projectId?: string | undefined;
    input?: DeleteThreadSubscriptionInputModel | undefined;
}

export interface DeleteThreadSubscriptionInputModel {
    threadId?: string | undefined;
    userId?: string | undefined;
}

export interface ResultOfGetThreadSubscriptionsByUserOutputModel extends Result {
    data: GetThreadSubscriptionsByUserOutputModel;
}

export interface GetThreadSubscriptionsByUserOutputModel {
    threadsId?: string[] | undefined;
}

export interface GetThreadSubscriptionsByUserQuery {
    projectId?: string | undefined;
    input?: GetThreadSubscriptionsByUserInputModel | undefined;
}

export interface GetThreadSubscriptionsByUserInputModel {
    userId?: string | undefined;
}

export interface AddUserAccessThreadCommand {
    projectId?: string | undefined;
    input?: AddUserAccessThreadInputModel | undefined;
}

export interface AddUserAccessThreadInputModel {
    threadId?: string | undefined;
    createdBy?: string | undefined;
    users?: string[] | undefined;
}

export interface DeleteUserAccessThreadCommand {
    projectId?: string | undefined;
    input?: DeleteUserAccessThreadInputModel | undefined;
}

export interface DeleteUserAccessThreadInputModel {
    threadId?: string | undefined;
    users?: string[] | undefined;
}

export interface ResultOfGetUserAccessThreadOutputModel extends Result {
    data: GetUserAccessThreadOutputModel;
}

export interface GetUserAccessThreadOutputModel {
    users?: GetUserAccessThreadOutputUsersModel[] | undefined;
}

export interface GetUserAccessThreadOutputUsersModel {
    userId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
}

export interface GetUserAccessThreadQuery {
    projectId?: string | undefined;
    input?: GetUserAccessThreadInputModel | undefined;
}

export interface GetUserAccessThreadInputModel {
    threadId?: string | undefined;
}

export interface EditThreadCommand {
    projectId?: string | undefined;
    input?: EditThreadInputModel | undefined;
}

export interface EditThreadInputModel {
    threadId?: string | undefined;
    userId?: string | undefined;
    title?: string | undefined;
    isPublic?: boolean;
    sharedWith?: string[] | undefined;
}

export interface RestoreThreadCommand {
    projectId?: string | undefined;
    input?: RestoreThreadInputModel | undefined;
}

export interface RestoreThreadInputModel {
    threadId?: string | undefined;
}

export interface ResultOfGetThreadsCountSubscriptionsByUserOutputModel extends Result {
    data: GetThreadsCountSubscriptionsByUserOutputModel;
}

export interface GetThreadsCountSubscriptionsByUserOutputModel {
    assets?: GetThreadsCountSubscriptionsByUserOutputAssetsModel[] | undefined;
}

export interface GetThreadsCountSubscriptionsByUserOutputAssetsModel {
    assetId?: string | undefined;
    count?: number;
}

export interface GetThreadsCountSubscriptionsByUserQuery {
    projectId?: string | undefined;
    input?: GetThreadsCountSubscriptionsByUserInputModel | undefined;
}

export interface GetThreadsCountSubscriptionsByUserInputModel {
    projectId?: string | undefined;
    userId?: string | undefined;
}

export interface ResultOfGetUnreadMessagesByThreadOutputModel extends Result {
    data: GetUnreadMessagesByThreadOutputModel;
}

export interface GetUnreadMessagesByThreadOutputModel {
    unreadMessages?: GetUnreadMessagesByThreadOutputThreadsModel[] | undefined;
}

export interface GetUnreadMessagesByThreadOutputThreadsModel {
    threadId?: string | undefined;
    count?: number;
}

export interface GetUnreadMessagesByThreadQuery {
    projectId?: string | undefined;
    input?: GetUnreadMessagesByThreadInputModel | undefined;
}

export interface GetUnreadMessagesByThreadInputModel {
    userId?: string | undefined;
    assetId?: string | undefined;
}

export interface ResultOfIListOfDocumentManagerDto extends Result {
    data: DocumentManagerDto[];
}

export interface ApplicationEntityDto {
    id: string;
    createdBy: string;
    created: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;
    deletedBy?: string | undefined;
    deleted?: Date | undefined;
}

export interface ResourceDto extends ApplicationEntityDto {
    name: string;
    description: string;
    owner: string;
    tags: string[];
    public: boolean;
    deactivated: boolean;
}

export interface ProjectResourceDto extends ResourceDto {
    projectId: string;
    accessType: ProjectResourceAccessType;
}

export interface DocumentManagerDto extends ProjectResourceDto {
    managerType: DocumentManagerType;
    baseAddress: string;
    user: string;
}

export enum DocumentManagerType {
    NextCloud = 1,
    AzureBlobStorage = 2,
}

export enum ProjectResourceAccessType {
    Read = 1,
    Edit = 2,
}

export interface ResultOfDocumentManagerFullDto extends Result {
    data: DocumentManagerFullDto;
}

export interface DocumentManagerFullDto extends ProjectResourceDto {
    managerType: DocumentManagerType;
    baseAddress: string;
    user: string;
}

export interface ResultOfDocumentManagerDto extends Result {
    data: DocumentManagerDto;
}

export interface CreateProjectResourceCommandOfDocumentManagerDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
    projectId: string;
}

export interface CreateDocumentationManagerCommand extends CreateProjectResourceCommandOfDocumentManagerDto {
    managerType: DocumentManagerType;
    baseAddress: string;
    user: string;
    password: string;
}

export interface EditDocumentationManagerCommand extends CreateDocumentationManagerCommand {
    id: string;
}

export interface ResultOfListOfDocumentationElementVm extends Result {
    data: DocumentationElementVm[];
}

export interface DocumentationElementVm {
    id?: string | undefined;
    name: string;
    url: string;
    parentPath: string;
    isDirectory: boolean;
    assets: string[];
}

export interface GetDocumentElementsByPathQuery {
    documentationManagerId: string;
    path: string;
}

export interface ResultOfIListOfDocumentDto extends Result {
    data: DocumentDto[];
}

export interface DocumentDto extends ProjectResourceDto {
    url: string;
    isDirectory: boolean;
    managerType: DocumentManagerType;
    documentManagerName: string;
    size: number;
}

export interface DownloadDocumentCommand {
    documentId?: string | undefined;
}

export interface ResultOfDocumentAssetsModel extends Result {
    data: DocumentAssetsModel;
}

export interface UpdateFileTagsCommand {
    projectId?: string | undefined;
    documentAssets?: DocumentAssetsModel[] | undefined;
}

export interface DeleteFileTagsCommand {
    projectId?: string | undefined;
    documentAssets?: DocumentAssetsModel[] | undefined;
}

export interface DeleteInDocumentsAnAssetCommand {
    projectId?: string | undefined;
    tag?: string | undefined;
}

export interface DownloadDocumentationCommand {
    projectId?: string | undefined;
    documents?: DocumentsToDownload[] | undefined;
}

export interface DocumentsToDownload {
    blob?: string | undefined;
    id?: string | undefined;
}

export interface ResultOfDocumentsAssetsApiResponse extends Result {
    data: DocumentsAssetsApiResponse;
}

export interface DocumentsAssetsApiResponse {
    documents?: DocumentAssetsModel[] | undefined;
    foldersDocuments?: FolderDocumentsAssetsModel[] | undefined;
}

export interface DeleteFilesCommand {
    projectId?: string | undefined;
    configIds?: string[] | undefined;
}

export interface DeleteFoldersCommand {
    projectId?: string | undefined;
    routes?: string[] | undefined;
}

export interface ResultOfDocumentsTree extends Result {
    data: DocumentsTree;
}

export interface DocumentsTree {
    tree?: DocumentsTreeTree | undefined;
    information?: DocumentModel2[] | undefined;
}

export interface DocumentsTreeTree {
    folderName?: string | undefined;
    canDeleteFolder?: boolean;
    folders?: DocumentsTreeTree[] | undefined;
    files?: string[] | undefined;
}

export interface DocumentModel2 {
    projectId?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
    mimeType?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    tags?: string[] | undefined;
    blob?: string | undefined;
}

export interface CreateFolderCommand {
    projectId?: string | undefined;
    path?: string[] | undefined;
    folderName?: string | undefined;
}

export interface ResultOfGetAssetsDocumentsRelationsModel extends Result {
    data: GetAssetsDocumentsRelationsModel;
}

export interface GetAssetsDocumentsRelationsModel {
    documentsWithAssets?: AssetsDocumentsRelationsModel[] | undefined;
    assetsWithDocuments?: AssetsDocumentsRelationsModel[] | undefined;
    documents?: DocumentAssetsModel[] | undefined;
}

export interface AssetsDocumentsRelationsModel {
    parent?: string | undefined;
    childrens?: string[] | undefined;
}

export interface GetAssetsDocumentsRelationsQuery {
    projectId?: string | undefined;
}

export interface ResultOfForgeAccountRelatedResourcesVm extends Result {
    data: ForgeAccountRelatedResourcesVm;
}

export interface ForgeAccountRelatedResourcesVm {
    forgeObjects: number;
    projectForgeObjects: number;
}

export interface ResultOfIListOfForgeAccountDto extends Result {
    data: ForgeAccountDto[];
}

export interface ForgeAccountDto extends ResourceDto {
    clientId: string;
    accessType: ProjectResourceAccessType;
}

export interface ResultOfForgeAccountFullDto extends Result {
    data: ForgeAccountFullDto;
}

export interface ForgeAccountFullDto extends ForgeAccountDto {
    forgeObjects: string[];
}

export interface ResultOfForgeAccountDto extends Result {
    data: ForgeAccountDto;
}

export interface CreateResourceCommandOfForgeAccountDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface CreateForgeAccountCommand extends CreateResourceCommandOfForgeAccountDto {
    clientId: string;
    clientSecret: string;
}

export interface UpdateForgeAccountCommand extends CreateForgeAccountCommand {
    id: string;
}

export interface ResultOfForgeObjectRelatedResourcesVm extends Result {
    data: ForgeObjectRelatedResourcesVm;
}

export interface ForgeObjectRelatedResourcesVm {
    projectForgeObjects: number;
}

export interface ResultOfLongDocumentResult extends Result {
    data: LongDocumentResult;
}

export interface LongDocumentResult {
    data?: MemoryStream[] | undefined;
    fileName?: string | undefined;
}

export interface MarshalByRefObject {
}

export interface Stream extends MarshalByRefObject {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export interface MemoryStream extends Stream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
}

export interface ResultOfListOfForgeObjectMaterialDto extends Result {
    data: ForgeObjectMaterialDto[];
}

export interface ForgeObjectMaterialDto {
    name: string;
    order: number;
    color: string;
    opacity: number;
    transparent: boolean;
}

export interface AddModelMaterialsCommand {
    forgeObjectId: string;
    materials: ForgeObjectMaterialDto[];
}

export interface ResultOfForgePublicTokenVm extends Result {
    data: ForgePublicTokenVm;
}

export interface ForgePublicTokenVm {
    accessToken: string;
    tokenType: string;
    expiresIn: number;
}

export interface ResultOfListOfBucketObjectVm extends Result {
    data: BucketObjectVm[];
}

export interface BucketObjectVm {
    forgeAccountId: string;
    bucketKey: string;
    objectId: string;
    objectKey: string;
    forgeObjectStatus: ForgeObjectStatusEnum;
    thumbnail: string;
    status: ForgeObjectTranslationStatusEnum;
    region: ForgeRegionsType;
}

export enum ForgeObjectStatusEnum {
    NotExists = 0,
    Pending = 1,
    Processed = 2,
}

export enum ForgeObjectTranslationStatusEnum {
    Success = 1,
    InProgress = 2,
    Pending = 3,
}

export enum ForgeRegionsType {
    Us = 1,
    Emea = 2,
}

export interface CreateBucketCommand {
    bucketName: string;
    forgeAccountId: string;
}

export interface TranslateObjectCommand {
    forgeAccountId: string;
    objectId: string;
}

export interface ImportObjectCommand {
    bucketObjectVm: BucketObjectVm;
}

export interface SendHeatmapInput {
    heatmaps?: HeatmapGroupByUser[] | undefined;
}

export interface HeatmapGroupByUser {
    userId?: string | undefined;
    heatmap?: HeatmapGroup | undefined;
}

export interface HeatmapGroup {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    icon?: string | undefined;
    dbIdsToIsolate?: number[] | undefined;
    cuttingPlanes?: CuttinPlanesModel[] | undefined;
    heatmaps?: HeatmapsModel[] | undefined;
}

export interface CoordsModel {
    x?: number;
    y?: number;
    z?: number;
}

export interface CuttinPlanesModel extends CoordsModel {
    w?: number;
}

export interface HeatmapsModel {
    typeId?: string | undefined;
    typeName?: string | undefined;
    icon?: string | undefined;
    planarHeatmapData?: PlanarHeatmapDataModel | undefined;
    confidence?: number;
    legend?: LegendHeatmapModel | undefined;
    nodes?: NodesHeatmapModel[] | undefined;
}

export interface PlanarHeatmapDataModel {
    placementPosition?: number;
    slicingEnabled?: boolean;
}

export interface LegendHeatmapModel {
    name?: string | undefined;
    min?: number;
    max?: number;
    unit?: string | undefined;
    legendItems?: LegendItemsModel[] | undefined;
}

export interface LegendItemsModel {
    ruleName?: string | undefined;
    ruleColor?: string | undefined;
}

export interface NodesHeatmapModel {
    id?: string | undefined;
    dbIds?: number[] | undefined;
    points?: PointsModel[] | undefined;
}

export interface PointsModel {
    id?: string | undefined;
    value?: number;
    dbIds?: number[] | undefined;
    coord?: CoordsModel | undefined;
    projectTheFloor?: boolean;
    tooltipData?: TooltipDataModel | undefined;
}

export interface TooltipDataModel {
    type?: number;
    tooltip?: TooltipDataContentModel | undefined;
    style?: TooltipStyleModel | undefined;
}

export interface TooltipDataContentModel {
    type?: string | undefined;
    content?: string | undefined;
    data?: string | undefined;
}

export interface TooltipStyleModel {
    hexColor?: string | undefined;
}

export interface ResultOfIListOfTeamDto extends Result {
    data: TeamDto[];
}

export interface TeamDto extends ProjectResourceDto {
    users: string[];
}

export interface ResultOfTeamDto extends Result {
    data: TeamDto;
}

export interface ResultOfTeamRelatedResourcesVm extends Result {
    data: TeamRelatedResourcesVm;
}

export interface TeamRelatedResourcesVm {
    users: number;
}

export interface CreateProjectResourceCommandOfTeamDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
    projectId: string;
}

export interface CreateTeamCommand extends CreateProjectResourceCommandOfTeamDto {
    users: string[];
}

export interface UpdateTeamCommand extends CreateTeamCommand {
    id: string;
}

export interface ResultOfKBEquipmentContextDto extends Result {
    data: KBEquipmentContextDto;
}

export interface KBEquipmentContextDto extends ResourceDto {
    path: string;
}

export interface CreateResourceCommandOfKBEquipmentContextDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface AddKnowledgeBaseEquipmentContextCommand extends CreateResourceCommandOfKBEquipmentContextDto {
}

export interface UpdateKnowledgeBaseEquipmentContextCommand extends AddKnowledgeBaseEquipmentContextCommand {
    id: string;
}

export interface DownloadKBEquipmentContextCommand {
    kbEquipmentContextId: string;
    projectId: string;
    assetName: string;
    fileName: string;
}

export interface ResultOfIListOfKBEquipmentContextDto extends Result {
    data: KBEquipmentContextDto[];
}

export interface ResultOfListOfDocumentationVm extends Result {
    data: DocumentationVm[];
}

export interface DocumentationVm {
    name: string;
    url: string;
    parentPath: string;
    isDirectory: boolean;
}

export interface GetAssetKnowledgeBaseEquipmentContextQuery {
    assetName: string;
    projectId: string;
    kbEquipmentContextId: string;
}

export interface ResultOfPermissionsOperationVm extends Result {
    data: PermissionsOperationVm;
}

export interface PermissionsOperationVm {
    operationComplete: boolean;
}

export interface AddProjectResourcePermissionVm {
    userIds: string[];
    teamIds: string[];
    projectResourceIds: string[];
    accessType: ProjectResourceAccessType;
}

export interface UpdateProjectResourcePermissionVm {
    permissionsIds: string[];
    accessType: ProjectResourceAccessType;
}

export interface RemoveProjectResourcePermissionVm {
    permissionsIds: string[];
}

export interface ResultOfProjectResourcePermissionsVm extends Result {
    data: ProjectResourcePermissionsVm;
}

export interface ProjectResourcePermissionsVm {
    users?: UserResourceAccess[] | undefined;
    teams?: TeamResourceAccess[] | undefined;
}

export interface UserResourceAccess {
    userId?: string | undefined;
    accessType?: ProjectResourceAccessType;
}

export interface TeamResourceAccess {
    teamId?: string | undefined;
    teamName?: string | undefined;
    accessType?: ProjectResourceAccessType;
}

export interface ResultOfMonitoringManagerDto extends Result {
    data: MonitoringManagerDto;
}

export interface MonitoringManagerDto extends ProjectResourceDto {
    managerType: MonitoringManagerTypeEnum;
    baseAddress: string;
}

export enum MonitoringManagerTypeEnum {
    OPCUA = 1,
}

export interface CreateProjectResourceCommandOfMonitoringManagerDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
    projectId: string;
}

export interface CreateMonitoringManagerCommand extends CreateProjectResourceCommandOfMonitoringManagerDto {
    managerType: MonitoringManagerTypeEnum;
    baseAddress: string;
}

export interface EditMonitoringManagerCommand extends CreateMonitoringManagerCommand {
    id: string;
}

export interface ResultOfIListOfMonitoringManagerDto extends Result {
    data: MonitoringManagerDto[];
}

export interface MarkAsReadCommand {
    ids: number[];
    projectId?: string | undefined;
}

export interface ResultOfListOfUserNotificationDto extends Result {
    data: UserNotificationDto[];
}

export interface UserNotificationDto {
    ids: string;
    title: string;
    description: string;
    userId: string;
    read: boolean;
    created: Date;
    titleParams?: string | undefined;
    descriptionParams?: string | undefined;
    idComment?: string | undefined;
}

export interface ResultOfNotificationsNumberVm extends Result {
    data: NotificationsNumberVm;
}

export interface NotificationsNumberVm {
    number: number;
}

export interface ResultOfIListOfProjectPowerAppObjectDto extends Result {
    data: ProjectPowerAppObjectDto[];
}

export interface ProjectPowerAppObjectDto extends ProjectResourceDto {
    embedUrl: string;
}

export interface ResultOfListOfProjectPowerAppObjectDto extends Result {
    data: ProjectPowerAppObjectDto[];
}

export interface CreateProjectResourcesCommandOfAddPowerAppObjectDtoAndProjectPowerAppObjectDto {
    projectId: string;
    resources: AddPowerAppObjectDto[];
}

export interface AddPowerAppsCommand extends CreateProjectResourcesCommandOfAddPowerAppObjectDtoAndProjectPowerAppObjectDto {
}

export interface CreateResourceDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface AddPowerAppObjectDto extends CreateResourceDto {
    appId: string;
}

export interface DeleteProjectResourcesCommand {
    ids: string[];
    forceDelete: boolean;
    projectId: string;
}

export interface DeletePowerAppsCommand extends DeleteProjectResourcesCommand {
}

export interface ResultOfIListOfPowerBIAccountDto extends Result {
    data: PowerBIAccountDto[];
}

export interface PowerBIAccountDto extends ResourceDto {
    clientId: string;
    authenticationMode: PBIAuthenticationModesType;
    tenantId: string;
    masterUserAccountName: string;
    authorityUri: string;
    scopes: string;
    accessType: ProjectResourceAccessType;
}

export enum PBIAuthenticationModesType {
    MasterUser = 1,
    ServicePrincipal = 2,
}

export interface ResultOfPowerBIAccountDto extends Result {
    data: PowerBIAccountDto;
}

export interface CreateResourceCommandOfPowerBIAccountDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface CreatePowerBIAccountCommand extends CreateResourceCommandOfPowerBIAccountDto {
    clientId: string;
    authenticationMode: PBIAuthenticationModesType;
    clientSecret: string;
    tenantId: string;
    masterUserAccountName: string;
    masterUserPassword: string;
}

export interface UpdatePowerBIAccountCommand extends CreatePowerBIAccountCommand {
    id: string;
}

export interface ResultOfListOfPowerBIWorkspaceVm extends Result {
    data: PowerBIWorkspaceVm[];
}

export interface PowerBIWorkspaceVm {
    workspaceId: string;
    name: string;
}

export interface ResultOfListOfPowerBIWorkspaceObjectVm extends Result {
    data: PowerBIWorkspaceObjectVm[];
}

export interface PowerBIWorkspaceObjectVm {
    name: string;
    powerBIAccountId: string;
    embedUrl: string;
    type: PowerBIObjectType;
}

export enum PowerBIObjectType {
    Report = 1,
    Dashboard = 2,
}

export interface ResultOfListOfPowerBIObjectModelConfigurationDto extends Result {
    data: PowerBIObjectModelConfigurationDto[];
}

export interface PowerBIObjectModelConfigurationDto {
    id: string;
    projectPowerBIObjectId: string;
    pageId: string;
    pageName: string;
    visualId: string;
    visualName: string;
    visualAssetField: string;
}

export interface AddPowerBIObjectsModelConfigurationCommand {
    powerBIObjectsModelConfiguration: CreatePowerBIObjectModelConfigurationDto[];
}

export interface CreatePowerBIObjectModelConfigurationDto {
    projectPowerBIObjectId: string;
    pageId: string;
    pageName: string;
    visualId: string;
    visualName: string;
    visualAssetField: string;
}

export interface ResultOfListOfProjectPowerBIObjectDto extends Result {
    data: ProjectPowerBIObjectDto[];
}

export interface ProjectPowerBIObjectDto extends ProjectResourceDto {
    embedUrl: string;
    type: PowerBIObjectType;
    powerBIAccountId: string;
    modelConfigs: PowerBIObjectModelConfigurationDto[];
    isDefaultReport?: boolean;
}

export interface CreateProjectResourcesCommandOfAssingPowerBIObjectDtoAndProjectPowerBIObjectDto {
    projectId: string;
    resources: AssingPowerBIObjectDto[];
}

export interface AssingPowerBIObjectsCommand extends CreateProjectResourcesCommandOfAssingPowerBIObjectDtoAndProjectPowerBIObjectDto {
}

export interface AssingPowerBIObjectDto extends CreateResourceDto {
    powerBIAccountId: string;
    embedUrl: string;
    type: PowerBIObjectType;
}

export interface DeletePowerBIObjectsCommand extends DeleteProjectResourcesCommand {
}

export interface DeleteEntitiesCommand {
    ids: string[];
    forceDelete: boolean;
}

export interface DeletePowerBIObjectsConfigurationCommand extends DeleteEntitiesCommand {
}

export interface ResultOfIListOfProjectPowerBIObjectDto extends Result {
    data: ProjectPowerBIObjectDto[];
}

export interface ResultOfProjectPowerBIObjectFullDto extends Result {
    data: ProjectPowerBIObjectFullDto;
}

export interface ProjectPowerBIObjectFullDto extends ProjectPowerBIObjectDto {
    powerBIAccount: string;
    ruleSets: RuleSetDto[];
}

export interface RuleSetDto {
    id: string;
    name: string;
    rules: JsonDocument;
    collisionRules?: JsonDocument | undefined;
}

/** Provides a mechanism for examining the structural content of a JSON value without automatically instantiating data values. */
export interface JsonDocument {
    /** Gets the root element of this JSON document. */
    rootElement?: any;
}

export interface ResultOfIListOfProjectDto extends Result {
    data: ProjectDto[];
}

export interface ProjectDto extends ResourceDto {
    projectImageStr?: string | undefined;
    projectViewerLogoStr?: string | undefined;
    accessType: ProjectResourceAccessType;
    status?: ProjectStatusEnum;
    forgeObject?: ForgeObjectDto | undefined;
    projectAvailableLayouts?: { [key: string]: boolean; } | undefined;
}

export enum ProjectStatusEnum {
    Creating = 1,
    Updating = 2,
    Ready = 3,
}

export interface ForgeObjectDto extends ResourceDto {
    urn: string;
    forgeAccountId: string;
    thumbnailStr: string;
    status: ForgeObjectStatusEnum;
    accessType: ProjectResourceAccessType;
    materials: ForgeObjectMaterialDto[];
}

export interface ResultOfProjectDto extends Result {
    data: ProjectDto;
}

export interface ResultOfProjectRelatedResourcesVm extends Result {
    data: ProjectRelatedResourcesVm;
}

export interface ProjectRelatedResourcesVm {
    documents: number;
    documentationManagers: number;
    projectForgeObjects: number;
    teams: number;
}

export interface ResultOfProjectSummaryVm extends Result {
    data: ProjectSummaryVm;
}

export interface ProjectSummaryVm {
    documents: number;
    forgeObjects: number;
    teams: number;
}

export interface ResultOfProjectsCount extends Result {
    data: ProjectsCount;
}

export interface ProjectsCount {
    number: number;
}

export interface CreateResourceCommandOfProjectDto {
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface CreateProjectCommand extends CreateResourceCommandOfProjectDto {
    bucketObject: ProjectObjectVm;
    projectImage?: FileToUpload | undefined;
}

export interface ProjectObjectVm {
    forgeAccountId: string;
    bucketKey: string;
    objectId: string;
    region: ForgeRegionsType;
}

export interface FileToUpload {
    name?: string | undefined;
    fileName?: string | undefined;
    content?: string | undefined;
    contentType?: string | undefined;
    length?: number;
}

export interface UpdateProjectCommand {
    id: string;
    bucketObject?: ProjectObjectVm | undefined;
    projectImage?: FileToUpload | undefined;
    name: string;
    description: string;
    tags: string[];
    public: boolean;
}

export interface ResultOfIListOfForgeObjectDto extends Result {
    data: ForgeObjectDto[];
}

export interface ResultOfForgeObjectDto extends Result {
    data: ForgeObjectDto;
}

export interface ResultOfProjectPowerBIObjectDto extends Result {
    data: ProjectPowerBIObjectDto;
}

export interface GetProjectInfoAPIQuery {
    projectId: string;
}

export interface SetProjectUserDefaultDashboardCommand extends GetProjectInfoAPIQuery {
    projectPowerBIObjectId: string;
}

export interface ResultOfJsonDocument extends Result {
    data: JsonDocument;
}

export interface ResultOfIListOfRuleSetDto extends Result {
    data: RuleSetDto[];
}

export interface AddRuleSetsVm {
    ruleSetObjectId: string;
    ruleSets: RuleSetModel[];
}

export interface RuleSetModel {
    name: string;
    rules: JsonDocument;
    collisionRules?: JsonDocument | undefined;
}

export interface UpdateRuleSetsVm {
    ruleSetObjectId: string;
    ruleSets: RuleSetDto[];
}

export interface UpdateRuleSetObjectsVm {
    ruleSetId: string;
    ruleSetObjects: string[];
}

export interface RemoveRuleSetsVm {
    ruleSetObjectId: string;
    ruleSets: string[];
}

export interface GetObjectRuleSetsVm {
    ruleSetObjectId: string;
}

export interface ResultOfIListOfRuleSetObjectDetailVm extends Result {
    data: RuleSetObjectDetailVm[];
}

export interface RuleSetObjectDetailVm {
    id?: string | undefined;
    name?: string | undefined;
}

export interface GetRuleSetObjectsVm {
    ruleSetId: string;
}

export interface ResultOfRuleSetDto extends Result {
    data: RuleSetDto;
}

export interface AddCollisionSetRuleSetCommand {
    ruleSetId: string;
    collisionRules: JsonDocument;
}

export interface RemoveCollisionSetsCommand {
    ruleSetId: string;
}

export interface ResultOfIListOfRuleSetDetailVm extends Result {
    data: RuleSetDetailVm[];
}

export interface RuleSetDetailVm {
    id?: string | undefined;
    name?: string | undefined;
    type?: RuleSetObjectTypeEnum;
}

export enum RuleSetObjectTypeEnum {
    ProjectPowerBI = 1,
}

export interface ResultOfRegisterSignalModel extends Result {
    data: RegisterSignalModel;
}

export interface RegisterSignalModel {
    id?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    user?: string | undefined;
    signals?: string[] | undefined;
}

export interface ResultOfGetSignalsModel extends Result {
    data: GetSignalsModel;
}

export interface GetSignalsModel {
    signals?: GetSignalModel[] | undefined;
}

export interface GetSignalModel {
    info?: GetSignalInfoModel | undefined;
    measurements?: GetSignalMeasurementsModel[] | undefined;
}

export interface GetSignalInfoModel {
    h?: number | undefined;
    hh?: number | undefined;
    hhh?: number | undefined;
    l?: number | undefined;
    ll?: number | undefined;
    lll?: number | undefined;
    assetDescription?: string | undefined;
    assetId?: string | undefined;
    assetTag?: string | undefined;
    currentAlarm?: string | undefined;
    startDateTime?: Date | undefined;
    endDateTime?: Date | undefined;
    lastMeasurementTimestamp?: Date | undefined;
    lastMeasurementValue?: number | undefined;
    signalDescription?: string | undefined;
    signalId?: string | undefined;
    signalTag?: string | undefined;
    defaultStartDate?: Date | undefined;
    defaultEndDate?: Date | undefined;
    relativeTimePrior?: number | undefined;
    relativeTimeInterval?: string | undefined;
    unit?: string | undefined;
}

export interface GetSignalMeasurementsModel {
    avg?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    timestamp?: Date | undefined;
}

export interface GetSignalsQuery {
    projectId: string;
    signalIds?: string[] | undefined;
}

export interface ResultOfGetSignalModel extends Result {
    data: GetSignalModel;
}

export interface ResultOfGetSignalListModel extends Result {
    data: GetSignalListModel;
}

export interface GetSignalListModel {
    signals?: GetSignalListStructureModel[] | undefined;
}

export interface GetSignalListStructureModel {
    signalId?: string | undefined;
    signalTag?: string | undefined;
    signalDescription?: string | undefined;
    assetId?: string | undefined;
    assetTag?: string | undefined;
    assetDescription?: string | undefined;
}

export interface GetSignalListQuery {
    projectId: string;
}

export interface ResultOfListOfSignalsInformationModel extends Result {
    data: SignalsInformationModel[];
}

export interface SignalsInformationModel {
    idSignal?: string | undefined;
    tagSignal?: string | undefined;
    idAsset?: string | undefined;
    tagAsset?: string | undefined;
}

export interface GetSignalsInformationQuery {
    projectId: string;
}

export interface ResultOfGetGroupModel extends Result {
    data: GetGroupModel;
}

export interface GetGroupModel {
    groupDescription?: string | undefined;
    groupId?: string | undefined;
    groupName?: string | undefined;
    numberOfSignals?: number;
    defaultStartDate?: Date | undefined;
    defaultEndDate?: Date | undefined;
    relativeTimePrior?: number | undefined;
    relativeTimeInterval?: string | undefined;
    signals?: GetSignalModel[] | undefined;
}

export interface GetGroupQuery {
    projectId: string;
    groupId: string;
}

export interface ResultOfGetGroupsByUserModel extends Result {
    data: GetGroupsByUserModel;
}

export interface GetGroupsByUserModel {
    groups?: GetGroupsByUserStructureModel[] | undefined;
}

export interface GetGroupsByUserStructureModel {
    groupId?: string | undefined;
    groupName?: string | undefined;
    groupDescription?: string | undefined;
}

export interface GetGroupsByUserQuery {
    projectId: string;
}

export interface AddSignalInGroupCommand {
    projectId: string;
    idGroup: string;
    idSignals: string[];
}

export interface ResultOfListOfGroupsByUserModel extends Result {
    data: GroupsByUserModel[];
}

export interface GroupsByUserModel {
    idGroup?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultOfAssetSignalsModel extends Result {
    data: AssetSignalsModel;
}

export interface AssetSignalsModel {
    idSignal?: string | undefined;
    idAsset?: string | undefined;
    tagSignal?: string | undefined;
    tagAsset?: string | undefined;
    icon?: AssetSignalsIconModel | undefined;
    dbIds?: number[] | undefined;
    measurements?: AssetSignalsMeasurementModel[] | undefined;
}

export interface AssetSignalsMeasurementModel {
    timesTamp?: string | undefined;
    value?: string | undefined;
    unit?: string | undefined;
}

export interface ResultOfSignalsGroupsMonitoringModel extends Result {
    data: SignalsGroupsMonitoringModel;
}

export interface SignalsGroupsMonitoringModel {
    signalsGroups?: InformationSignalsGroups[] | undefined;
}

export interface InformationSignalsGroups {
    idSignal?: string | undefined;
    idsGroups?: string[] | undefined;
    defaultStartDate?: string | undefined;
    defaultEndDate?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    hhhValue?: string | undefined;
    hhValue?: string | undefined;
    hValue?: string | undefined;
    lValue?: string | undefined;
    llValue?: string | undefined;
    lllValue?: string | undefined;
    hasAlarm?: boolean;
    data?: AssetSignalsModel | undefined;
}

export interface ResultOfListOfAssetSignalsModel extends Result {
    data: AssetSignalsModel[];
}

export interface SignalsTimeloopModel {
    subscriptions?: SignalsTimeloopSubscriptionsModel[] | undefined;
}

export interface SignalsTimeloopSubscriptionsModel {
    userId?: string | undefined;
    data?: SignalsTimeloopDataModel[] | undefined;
}

export interface SignalsTimeloopDataModel {
    chartId?: string | undefined;
    signals?: SignalsTimeloopSignalsModel[] | undefined;
    newData?: boolean;
}

export interface SignalsTimeloopSignalsModel {
    signalId?: string | undefined;
    lastMeasurementTimestamp?: Date | undefined;
    lastMeasurementValue?: number | undefined;
    measurements?: SignalsTimeloopMeasurementsModel[] | undefined;
}

export interface SignalsTimeloopMeasurementsModel {
    avg?: number | undefined;
    max?: number | undefined;
    min?: number | undefined;
    timestamp?: Date | undefined;
}

export interface ChangeSubscribeSignalsCommand {
    projectId: string;
    connectionID?: string | undefined;
    userId?: string | undefined;
    signals?: SignalsSubscriptionSignalR[] | undefined;
}

export interface SignalsSubscriptionSignalR {
    chartId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface EncryptStringQuery {
    hash?: string | undefined;
}

export interface CreateAzureUsers {
    projectId?: string | undefined;
    users?: CreateAzureUserModel[] | undefined;
}

export interface CreateAzureUserModel {
    name?: string | undefined;
    email?: string | undefined;
    roleId?: string | undefined;
    isNewUser?: boolean;
    allowAccess?: boolean;
}

export interface ResultOfListOfResetUsersPasswordModel extends Result {
    data: ResetUsersPasswordModel[];
}

export interface ResetUsersPasswordModel {
    userId?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
}

export interface ResetUsersPassword {
    projectId?: string | undefined;
    users?: ResetUsersPasswordModel[] | undefined;
}

export interface ChangeNamePasswordUser {
    projectId?: string | undefined;
    changeName?: boolean;
    changePassword?: boolean;
    user?: ChangeNamePasswordUserModel | undefined;
}

export interface ChangeNamePasswordUserModel {
    userId?: string | undefined;
    name?: string | undefined;
    password?: string | undefined;
}

export interface ResultOfListOfAppRoleAssignment extends Result {
    data: AppRoleAssignment[];
}

/** The type Entity. */
export interface Entity {
    /** Gets or sets id.
Read-only. */
    id?: string | undefined;
    /** Gets or sets @odata.type. */
    "@odata.type"?: string | undefined;

    [key: string]: any;
}

/** The type Directory Object. */
export interface DirectoryObject extends Entity {
    /** Gets or sets deleted date time. */
    deletedDateTime?: Date | undefined;

    [key: string]: any;
}

/** The type App Role Assignment. */
export interface AppRoleAssignment extends DirectoryObject {
    /** Gets or sets app role id.
The identifier (id) for the app role which is assigned to the principal. This app role must be exposed in the appRoles property on the resource application's service principal (resourceId). If the resource application has not declared any app roles, a default app role ID of 00000000-0000-0000-0000-000000000000 can be specified to signal that the principal is assigned to the resource app without any specific app roles. Required on create. */
    appRoleId?: string | undefined;
    /** Gets or sets created date time.
The time when the app role assignment was created.The Timestamp type represents date and time information using ISO 8601 format and is always in UTC time. For example, midnight UTC on Jan 1, 2014 is 2014-01-01T00:00:00Z. Read-only. */
    createdDateTime?: Date | undefined;
    /** Gets or sets principal display name.
The display name of the user, group, or service principal that was granted the app role assignment. Read-only. Supports $filter (eq and startswith). */
    principalDisplayName?: string | undefined;
    /** Gets or sets principal id.
The unique identifier (id) for the user, group or service principal being granted the app role. Required on create. */
    principalId?: string | undefined;
    /** Gets or sets principal type.
The type of the assigned principal. This can either be User, Group or ServicePrincipal. Read-only. */
    principalType?: string | undefined;
    /** Gets or sets resource display name.
The display name of the resource app's service principal to which the assignment is made. */
    resourceDisplayName?: string | undefined;
    /** Gets or sets resource id.
The unique identifier (id) for the resource service principal for which the assignment is made. Required on create. Supports $filter (eq only). */
    resourceId?: string | undefined;

    [key: string]: any;
}

export interface GetAvailableRoles {
    projectId?: string | undefined;
}

export interface GetValidDomain {
    projectId?: string | undefined;
}

export interface GetUsersFromAzureTenantQuery {
    projectId: string;
}

export interface ModifyUsersInGroups {
    projectId?: string | undefined;
    groups?: ModifyUsersInGroupsModel[] | undefined;
}

export interface ModifyUsersInGroupsModel {
    groupId?: string | undefined;
    addUsers?: boolean;
    userIds?: string[] | undefined;
}

export interface ResultOfUserInformation extends Result {
    data: UserInformation;
}

export interface AuditableEntity {
    createdBy?: string | undefined;
    created?: Date;
    lastModifiedBy?: string | undefined;
    lastModified?: Date | undefined;
    deletedBy?: string | undefined;
    deleted?: Date | undefined;
}

export interface UserInformation extends AuditableEntity {
    id?: number;
    userId?: string | undefined;
    username?: string | undefined;
    photo?: string | undefined;
    mail?: string | undefined;
}

export interface SetUserInformationCommand {
}

export interface SetAllUsersInformationCommand {
}

export interface ResultOfUsersWithPermits extends Result {
    data: UsersWithPermits;
}

export interface UsersModel {
    users?: UserPermitsModel[] | undefined;
}

export interface UsersWithPermits extends UsersModel {
    projectId?: string | undefined;
    permits?: PermitsModel[] | undefined;
}

export interface PermitsModel {
    id?: string | undefined;
    type?: string | undefined;
}

export interface UserPermitsModel {
    userId?: string | undefined;
    userName?: string | undefined;
    userMail?: string | undefined;
    userPhoto?: string | undefined;
    roles?: string | undefined;
    roleId?: string | undefined;
    sections?: SectionsModel[] | undefined;
}

export interface SectionsSimpleModel {
    sectionId?: string | undefined;
    sectionName?: string | undefined;
}

export interface SectionsWithPermitsModel extends SectionsSimpleModel {
    rolePermits?: string | undefined;
}

export interface SectionsModel extends SectionsWithPermitsModel {
    customPermits?: string | undefined;
    validUntil?: string | undefined;
}

export interface GetUsersWithPermitsQuery {
    projectId: string;
}

export interface ResultOfUserWithPermits extends Result {
    data: UserWithPermits;
}

export interface UserWithPermits {
    projectId?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    userMail?: string | undefined;
    userPhoto?: string | undefined;
    roles?: string | undefined;
    roleId?: string | undefined;
    sections?: { [key: string]: UserWithPermitsSections; } | undefined;
}

export interface UserWithPermitsSections {
    modules?: { [key: string]: boolean; } | undefined;
    sectionId?: string | undefined;
    sectionName?: string | undefined;
}

export interface GetUserWithPermitsQuery {
    projectId: string;
    userId: string;
}

export interface ResultOfUsersByRole extends Result {
    data: UsersByRole;
}

export interface UsersByRole extends UsersModel {
    projectId?: string | undefined;
}

export interface GetUsersByRoleQuery {
    projectId: string;
    roleId: string;
}

export interface ResultOfRolesModel extends Result {
    data: RolesModel;
}

export interface RolesModel {
    roles?: RolesListModel[] | undefined;
}

export interface RolesListModel {
    roleId?: string | undefined;
    roleName?: string | undefined;
    sections?: SectionsWithPermitsModel[] | undefined;
    associateCount?: number;
}

export interface GetRolesQuery {
    projectId: string;
}

export interface ResultOfGetDefaultRoleOutput extends Result {
    data: GetDefaultRoleOutput;
}

export interface GetDefaultRoleOutput {
    roleId?: string | undefined;
    roles?: string | undefined;
}

export interface GetDefaultRoleQuery {
    projectId: string;
}

export interface ResultOfUsersPermitsModel extends Result {
    data: UsersPermitsModel;
}

export interface UsersPermitsModel {
    accessLevels?: PermitsAccessLevels[] | undefined;
    modules?: PermitsModules[] | undefined;
    users?: UsersPermits[] | undefined;
}

export interface PermitsAccessLevels {
    id?: string | undefined;
    accessLevel?: number;
    type?: string | undefined;
    isDefault?: boolean;
}

export interface PermitsModules {
    id?: string | undefined;
    moduleName?: string | undefined;
}

export interface UserDetailsPermits {
    userName?: string | undefined;
    userPhoto?: string | undefined;
    userMail?: string | undefined;
}

export interface UsersPermits extends UserDetailsPermits {
    userId?: string | undefined;
    modules?: UserPermitsModules[] | undefined;
}

export interface UserPermitsModules {
    moduleId?: string | undefined;
    accessLevelId?: string | undefined;
    accessLevel?: number;
    expirationDate?: Date | undefined;
}

export interface GetUsersPermitsQuery {
    projectId?: string | undefined;
}

export interface UpdateUsersPermitsQuery {
    projectId?: string | undefined;
    users?: UserPermits[] | undefined;
}

export interface UserPermits {
    userId?: string | undefined;
    modules?: UserPermitsModules[] | undefined;
}

export interface ResultOfDictionaryOfStringAndShort extends Result {
    data: { [key: string]: number; };
}

export interface GetUserPermitsQuery {
    projectId?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export interface IConfig {
    getAuthorization: () => Promise<string>;
}